// Copyright (c) 2016 Deere & Company

export default Object.freeze({
  A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: "Ya existe un dise\xF1o de p\xE1gina con este nombre",
  ACCEPT: "Aceptar",
  ACCEPT_ALL: "Aceptar Todos",
  ACCEPT_REJECT_TRANSFER_PENDING: "Aprobaci\xF3n pendiente",
  ACCEPTED: "Aceptado",
  ACCOUNT: "Cuentas",
  ACCOUNT_ADDRESS: "Direcci\xF3n de Concesi\xF3n",
  ACCOUNT_COUNTRY: "Pa\xEDs del concesionario",
  ACCOUNT_END: "Fin de cuenta",
  ACCOUNT_NAME: "Nombre del concesionario",
  ACCOUNT_NUMBER: "N\xFAmero de cuenta",
  ACCOUNT_NUMBER_REQUIRED: "Se Requiere N\xBA Cuenta de Concesi\xF3n",
  ACCOUNTS: "Cuentas",
  ACCUMULATED_DAYS_ON_RENT: "D\xEDas de Alquiler Acumulados",
  ACCUMULATED_DAYS_RENTED: "D\xEDas de Alquiler Acumulado",
  ACTIONS: "Acciones",
  ACTIVE_WARRANTY: "Garant\xEDa Activa",
  ACTIVE_WARRANTY_CLICK_FOR_DETAIL: "Garant\xEDa Activa (Hacer clic para conocer los detalles)",
  ACTUAL_AUDIT: "Auditor\xEDa Real",
  ACTUAL_AUDIT_DATE: "Fecha de auditor\xEDa real",
  ACTUAL_COURIER_NAME: "Nombre del Servicio de Mensajer\xEDa Real",
  ACTUAL_HOURS: "Horas Reales",
  ADD_CLAIM: "Agregar Reclamaci\xF3n",
  ADD_CLAIMS: "Agregar Reclamaciones",
  ADD_COMPONENT: "Add Component",
  ADD_OPTION: "A\xF1adir Opci\xF3n",
  ADD_REP: "Reparo Adicional",
  ADD_TO_AUDIT: "Agregar a Auditor\xEDa",
  ADDITIONAL: "Adicional",
  ADDITIONAL_COMMENTS: "Comentarios Adicionales",
  ADDITIONAL_REPAIR: "Reparo Adicional",
  ADDITIVE: "Suplementario",
  ADDRESS: "Direcci\xF3n",
  ADDRESS_LINE1: "L\xEDnea de direcci\xF3n 1",
  ADDRESS_LINE1_REQUIRED: "Se requiere la l\xEDnea 1 de direcci\xF3n",
  ADDRESS_LINE2: "L\xEDnea de direcci\xF3n 2",
  ADJ_CLM: "Ajustar Reclamaci\xF3n",
  ADJUST_CLAIM: "Ajustar Reclamaci\xF3n",
  ADJUSTED_HOURS: "Horas ajustadas",
  ADJUSTED_QUANTITY: "Cantidad ajustada",
  ADJUSTMENT_TYPE: "Tipo de Ajuste",
  ADVANCED_CLAIM_SUMMARY: "Avanzado Resume de Reclamaci\xF3n",
  AFTER_DELIVERY_INSPECTION: "LUEGO DE LA INSPECCI\xD3N DE ENTREGA",
  AGENCY_NAME: "Nombre de Agencia",
  ALL: "Todos",
  ALL_ACCOUNTS: "Todas las Cuentas",
  ALL_CLAIMS: "Todas las Reclamaciones",
  ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: "Todas las reclamaciones est\xE1n sujetas a revisi\xF3n (ver JD WAM 110.08 para m\xE1s informaci\xF3n)",
  ALL_CLAIMS_TAB: "Todas las Reclamaciones ({count, number})",
  ALL_PART_REQUESTS: "Todas las Solicitudes de Piezas",
  ALL_PART_REQUESTS_WITH_COUNT: "Todas las Solicitudes de Piezas ({count})",
  ALL_PARTS_RETURNED: "Todas las Piezas Devueltas",
  AMOUNT: "Monto",
  AMOUNT_1: "Monto 1",
  AMOUNT_2: "Monto 2",
  AMOUNT_3: "Monto 3",
  AMOUNT_OF_USE: "Horas de Trabajo",
  AMOUNT_OF_USE_HISTORY_WITH_COUNT: "Cantidad de Historial de Uso ({count})",
  AMOUNT_OF_USE_IS_REQUIRED: "El campo Cantidad de Uso es requerido.",
  AMOUNT_OF_USE_REQUIRED: "Cantidad de uso requerido",
  AMOUNT_OF_USE_UNITS_REQUIRED: "Cantidad de unidades usadas requeridas",
  AMOUNT_RECORDED: "Cantidad Registrada",
  AMOUNT_TO_BE_DEBITED: "Cantidad que se debe debitar",
  APLYPIP: "Aplicar PIP",
  APPLICATION: "Aplicaci\xF3n",
  APPLICATION_IS_REQUIRED: "El campo Aplicaci\xF3n es requerido.",
  APPLY: "Aplicar",
  APPLY_TRAVEL: "Aplicar Viaje",
  APPROVAL_DEALER_COMMENTS: "Comentarios de Aprobaci\xF3n de Concesi\xF3n/Distr.",
  APPROVAL_DETAILS: "Detalles de Aprobaci\xF3n",
  APPROVAL_LEVELS: "Niveles de aprobaci\xF3n",
  APPROVAL_REMARKS: "Observaciones de aprobaci\xF3n",
  APPROVAL_STATUS: "Estado de aprobaci\xF3n",
  APPROVE: "Aprobar",
  APPROVE_LABOR_RATE: "Aprobar Tarifa de Mano de Obra",
  APPROVE_MACHINE_STATUS_UPDATE: "Aprobar Actualizaci\xF3n de Estado de M\xE1quina",
  APPROVE_PIP_CODE_REQUEST: "Aprobar Solicitud de c\xF3digo PIP",
  APPROVE_SPECIAL_ALLOWANCE_CLAIM: "Aprobar Reclamaci\xF3n de Asignaci\xF3n Especial",
  APPROVED: "Aprobada",
  APPROVED_CORE_VALUE: "Valor Material Aprobado",
  APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: "La fecha de aprobaci\xF3n no puede ser anterior a la fecha de configuraci\xF3n.",
  APPROVED_DIAGNOSTIC_AMOUNT: "Monto de diagn\xF3stico aprobado",
  APPROVED_DIAGNOSTIC_HOURS: "Horas de diagn\xF3stico aprobadas",
  APPROVED_IS_REQUIRED: "El campo Aprobado es obligatorio.",
  APPROVED_LABOR_ADDITIVE: "Suplementario de Mano de Obra Aprobada",
  APPROVED_LABOR_AMOUNT: "Cantidad de Mano de Obra Aprobada",
  APPROVED_LABOR_HOURS: "Horas de Mano de Obra Aprobadas",
  APPROVED_LABOR_TOTAL: "Total de Mano de obra Aprobada",
  APPROVED_ON_SHELF_COST: "Costo del estante aprobado",
  APPROVED_OTHER_CREDITS: "Otros Cr\xE9ditos Aprobados",
  APPROVED_PARTS: "Piezas Aprobadas",
  APPROVED_PARTS_ADDITIVE: "Aditivo de partes est\xE1 aprobado",
  APPROVED_PARTS_TOTAL: "Total de partes aprobadas",
  APPROVED_REJECTED: "Aprobado/Rechazado",
  APPROVED_REPAIR_AMOUNT: "Monto de reparaci\xF3n aprobada",
  APPROVED_REPAIR_HOURS: "Horas de reparaci\xF3n aprobadas",
  APPROVED_TAXES_TOTAL: "Total de impuestos aprobados",
  APPROVED_TRAVEL_TOTAL: "Total de viajes aprobado",
  APPROVER: "Aprobador",
  ASCENDING: "Ascendente",
  ATTACHMENTS: "adjunci\xF3n",
  AUDIT_NUMBER: "N\xFAmero de Auditor\xEDa",
  AUDIT_PLANNED: "Auditor\xEDa Planificada",
  AUDIT_REQUIREMENT: "Requisito de Auditor\xEDa",
  AUDIT_RESULTS: "Resultados de auditor\xEDas",
  AUDIT_STATUS: "Estado de la Auditor\xEDa",
  AUDIT_SUBMITTED_SUCCESSFULLY: "Auditor\xEDa enviada con \xE9xito",
  AUDIT_SUMMARY: "Resumen de Auditor\xEDa",
  AUDIT_TYPE: "Tipo de Auditor\xEDa",
  AUDITS: "Auditor\xEDas",
  AUDITS_DUE_WITH_COUNT: "{countToDisplay} auditor\xEDas previstas",
  AUDITS_DUE_WITHIN_30_DAYS: "{countToDisplay} {count, plural, one {audit} other {audits}} previstas dentro de los 30 d\xEDas",
  AUDITS_PAST_DUE_WITH_COUNT: "{countToDisplay} {count, plural, one {audit} other {audits}} atrasadas",
  AUTHORIZATION_NUMBER: "N\xBA de Autorizaci\xF3n",
  AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: "Enviar Autom\xE1ticamente desde el Sistema Comercial del Concesionario",
  AVAILABLE: "Disponible",
  AVAILABLE_COLUMNS: "Columnas Disponibles",
  AVERAGE_DIAGNOSTICS_HOURS: "Horas de Diagn\xF3stico Promedio",
  AVERAGE_LUG_HEIGHT: "Altura promedio del callo",
  AVERAGE_LUG_HEIGHT_IS_REQUIRED: "El campo Altura Promedio de las Salientes es obligatorio.",
  AVERAGE_REPAIR_HOURS: "Horas de Reparaci\xF3n Promedio",
  AVERAGE_REPLACEMENT_HOURS: "Horas de Reemplazo Promedio",
  AVERAGE_TECH_PAY_RATE: "tasa promedio de mano de obra t\xE9cnica",
  BACK: "Regresar",
  BACK_TO_AUDIT: "Volver a Auditor\xEDa",
  BASE_MACHINE: "Base de Maquina",
  BASE_MACHINE_IMPLEMENTS: "Aperos de la m\xE1quina b\xE1sica",
  BASE_MACHINE_PIN: "PIN de la m\xE1quina base",
  BASIC_WARRANTY_ENDS: "Finalizaci\xF3n de la Garant\xEDa B\xE1sica",
  BASIC_WARRANTY_ESTIMATOR: "Estimador b\xE1sico de la garant\xEDa",
  BASIC_WARRANTY_STARTS: "Inicio de la Garant\xEDa B\xE1sica",
  BASIS_FOR_SETTLEMENT: "Bases para el arreglo",
  BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: "Bases para el arreglo / Comentarios de auditor\xEDa",
  BASIS_FOR_SETTLEMENT_IS_REQUIRED: "Bases para el arreglo se requiere.",
  BATTERY: "Bater\xEDa",
  BEGIN_DATE: "Fecha de Inicio",
  BRANCH: "Sucursal",
  BUILT: "Crear",
  BUSINESS_END: "Fin de la empresa",
  CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: "\xBFEs posible poner nuevamente en funcionamiento la m\xE1quina?",
  CANCEL: "Cancelar",
  CERTIFIED_LETTER_SENT: "Carta Certificada Enviada",
  CGST: "CGST",
  CHANGE_RESPONSIBLE_DEALER: "Cambiar la concesi\xF3n responsable",
  CHANGE_STATUS: "Cambiar Estatus",
  CHANGE_STATUS_FOR: "Cambiar Estado para {pin}",
  CHANGED: "Cambiado",
  CHANGED_BY: "Actualizado Por",
  CHANGED_ON: "Cambio En",
  CHINESE: "Chino",
  CITY: "Ciudad",
  CITY_REQUIRED: "Ciudad requerida",
  CLAIM: "Reclamaci\xF3n",
  CLAIM_COUNT_WITH_PARENTHESIS: "({countToDisplay} {count, plural, one {Reclamaci\xF3n} other {Reclamaciones}})",
  CLAIM_DEBIT: "Reclamar D\xE9bito",
  CLAIM_DETAILS: "Detalles de la Reclamaci\xF3n",
  CLAIM_DRAFT: "BORRADOR",
  CLAIM_HISTORY: "Historial de reclamaciones de 24 meses",
  CLAIM_HISTORY_WITH_COUNT: "Historial de reclamaciones de 24 meses ({count})",
  CLAIM_NUMBER: "N\xBA de Reclamaci\xF3n",
  CLAIM_RECOVER_PERCENTAGE: "({percentage}%)",
  CLAIM_SEARCH: "B\xFAsqueda de Reclamaci\xF3n",
  CLAIM_STATUS: "Estado de las Reclamaciones",
  CLAIM_TYPE: "Tipo de Reclamaci\xF3n",
  CLAIM_TYPES: "Tipos de Reclamaciones",
  CLAIM_UPDATED_SUCCESSFULLY: "Reclamo actualizado con \xE9xito",
  CLAIM_VALUE: "Valor de la Reclamaci\xF3n",
  CLAIM_VALUE_DETAILS: "Detalles del Valor de la Reclamaci\xF3n",
  CLAIM_WITH_NUMBER: "Reclamaci\xF3n {claimNumber}",
  CLAIMS: "Reclamaciones",
  CLAIMS_IN_PROGRESS: "Reclamaciones En Progreso",
  CLAIMS_IN_PROGRESS_WITH_COUNT: "Reclamaciones En Progreso ({count})",
  CLAIMS_OVERVIEW: "Descripci\xF3n General de las Reclamaciones",
  CLAIMS_OVERVIEW_TAB: "Descripci\xF3n General de las Reclamaciones {count}",
  CLAIMS_WITH_COUNT: "{count} Reclamaciones",
  CLICK_FOR_DETAILS: "(Haga clic para obtener detalles)",
  CLICK_TO_VIEW_ALL: "Haga clic para Ver Todo",
  CLOSE: "Cerrar",
  CLOSED_PART_REQUESTS: "Solicitudes de partes cerradas",
  CLOSING: "Cierre",
  CLOSING_ACCOUNT: "Cuenta de cierre",
  CLOSING_ACCOUNT_WITH_COUNT: "Cuenta de cierre ({count})",
  CODE: "C\xF3digo",
  COLLAPSE_ALL: "Contraer Todo",
  COMMENT: "Comentario",
  COMMENTS: "Comentarios",
  COMMENTS_IS_REQUIRED: "Comentarios son obligatorio.",
  COMMENTS_TO_DEALER: "Comentarios al concesionario",
  COMMON_LABOR_TYPES_WARNING: "No todos los tipos de mano de obra disponibles para las cuentas seleccionadas",
  COMPANY: "Empresa",
  COMPANY_CONTRIBUTION: "Contribuci\xF3n de Compa\xF1\xEDa",
  COMPANY_CONTRIBUTION_IS_REQUIRED: "Contribuci\xF3n de Empresa es obligatorio.",
  COMPLAINT_CAUSE: "\xBFCu\xE1l fue la causa de la queja?",
  COMPLAINT_CAUSE_IS_REQUIRED: "La causa de la queja es necesaria.",
  COMPLAINT_CORRECTION: "\xBFC\xF3mo se corrigi\xF3 la queja?",
  COMPLAINT_CORRECTION_IS_REQUIRED: "Requiere correcci\xF3n de la queja.",
  COMPLETE: "Completo",
  COMPLETED: "Realizado",
  COMPLETED_BY: "Realizado en",
  COMPLETED_DATE: "Fecha completada",
  COMPLETED_IN_LAST_24_MONTHS: "Completado en los \xDAltimos 24 Meses",
  COMPLETION_STATUS: "Estado de Finalizaci\xF3n",
  COMPONENT: "Componente",
  COMPONENT_CODE: "Component Code",
  COMPONENT_CREATED_SUCCESSFULLY: "Component Created Successfully",
  COMPONENT_DELETED_SUCCESSFULLY: "Component Deleted Successfully",
  COMPONENT_SERIAL_NUMBER: "N\xFAmero de Serie de Componente",
  COMPONENT_SUCCESSFULLY_UPDATED: "Componente actualizado con \xE9xito",
  COMPONENTS: "Componentes",
  CONFIRM: "Confirmar",
  CONFIRM_ADDITIONAL_REPAIR: "\xBFEst\xE1 seguro de que desea a\xF1adir una reparaci\xF3n adicional?",
  CONFIRM_ADJUST_CLAIM: "\xBFEst\xE1 seguro de que desea ajustar esta Reclamaci\xF3n?",
  CONFIRM_CLOSING_ACCOUNT: "\xBFEst\xE1 seguro de que desea aceptar esta transferencia?",
  CONFIRM_COPY_CLAIM: "\xBFEst\xE1 seguro de que quiere copiar la Reclamaci\xF3n?",
  CONFIRM_DELETE_ATTACHMENT: "\xBFSeguro que quieres borrar el archivo adjunto?",
  CONFIRM_DELETE_CLAIM: "\xBFEst\xE1 seguro de que quiere eliminar esta Reclamaci\xF3n?",
  CONFIRM_DELETE_REGISTRATION: "\xBFEst\xE1 seguro de que quiere eliminar este Registro?",
  CONFIRM_EDIT_CLAIM: "\xBFEst\xE1 seguro de que quiere editar esta Reclamaci\xF3n?",
  CONFIRM_RECONCILE_CLAIM: "\xBFEst\xE1 seguro de que desea reconciliar esta Reclamaci\xF3n?",
  CONFIRM_RESEND_XML: "\xBFEst\xE1 seguro de que desea volver a enviar XML? Deje 24-48 horas para que sea visible.",
  CONFIRM_SKIP_AUDIT: "\xBFEst\xE1 seguro de que quieres saltearte esta auditor\xEDa?",
  CONFIRM_UNDO_REGISTRATION: "\xBFEst\xE1 seguro de que desea anular este registro?",
  CONTACTED: "Contactado",
  CONTAINS: "Contiene",
  CONTRACT_NUMBER: "N\xFAmero de Contrato",
  CONTRACT_PURCHASED: "Contrato Adquirido",
  CONTRACT_TYPE: "Tipo de Contrato",
  COPY_CLAIM: "Copiar Reclamaci\xF3n",
  CORE: "Competencias",
  CORE_VALUE: "Valor de N\xFAcleo",
  COUNTRY: "Pa\xEDs",
  COUNTRY_REQUIRED: "Pa\xEDs requerido",
  COURIER_ACCOUNT_NUMBER: "N\xFAmero de Cuenta del Servicio de Mensajer\xEDa",
  COURIER_NAME: "Nombre de Transportista",
  COVERAGE_DECISION: "Decisi\xF3n de cobertura",
  COVERAGE_TYPE: "Tipo de cobertura",
  CRDMEM: "Nota de Credito",
  CREATE: "Crear",
  CREATE_CLAIM: "Crea Reclamaci\xF3n",
  CREATE_LAYOUT: "Creatar Dise\xF1o de p\xE1gina",
  CREATE_NON_TRACKED_PIN_HELP_TEXT: "Antes de poder presentar una reclamaci\xF3n sobre este producto, debe informarnos alguna informaci\xF3n importante sobre el mismo",
  CREATE_PIP_CLAIM: "Crear Reclamacion de PIP",
  CREATE_PIP_CLAIMS: "Crear Reclamaciones de PIP",
  CREATE_PRODUCT_RECORD: "Crear Registro del Producto",
  CREATE_REQUEST: "Crear solicitud",
  CREATE_TRANSFER_PENDING: "Transferencia pendiente",
  CREATE_TRANSFER_SERVICE_UNAVAILABLE: "Crear Servicios de Transferencia No Disponible",
  CREATED: "Creado",
  CREATED_BY: "Creado por",
  CREATED_DATE: "Fecha de Creaci\xF3n",
  CREATED_ON: "Creado el",
  CREATION_DATE: "Fecha de Creaci\xF3n",
  CREDIT_MEMO: "Nota de Cr\xE9dito",
  CREDIT_MEMO_DATE: "Fecha de la nota de cr\xE9dito",
  CREDIT_MEMO_ISSUE_DATE: "Nota de cr\xE9dito emitida",
  CREDIT_MEMO_NUMBER: "N\xFAmero de la nota de cr\xE9dito",
  CREDIT_MEMO_PROCESS_DATE: "Nota de Cr\xE9dito Procesado",
  CREDIT_MEMO_SELECTED: "Nota de Cr\xE9dito Seleccionada",
  CREDIT_MEMOS: "Notas de cr\xE9dito",
  CRITERIA: "Criterios",
  CRT: "Crear",
  CSV_SEPARATOR: "Separador CSV",
  CURRENCY: "Moneda",
  CURRENT: "Presente",
  CURRENT_ACCOUNT: "Cuenta corriente",
  CURRENT_AMOUNT_OF_USE: "Horas de Trabajo Actuales",
  CURRENT_CUSTOMER: "Cliente Actual",
  CURRENT_DEALER: "Concesionario/Distr Actual",
  CURRENT_DEALER_DISTANCE: "Distancia actual del concesionario",
  CURRENT_DEALER_LAST_SERVICE_DATE: "\xDAltima fecha de servicio del concesionario actual",
  CURRENT_DEALER_LOCATION: "Ubicaci\xF3n Actual del Concesionario",
  CURRENT_HOURS: "Horas actuales",
  CURRENT_QUANTITY: "Cantidad actual",
  CURRENT_RESPONSIBLE_DEALER: "Concesionario Responsable Actual",
  CURRENT_VALUES: "Valores Actuales",
  CURRENTLY_ON_RENT: "Actualmente en Alquiler",
  CUSTOM_RANGE: "Personalizar Rango",
  CUSTOM_VALUES: "Valores Personalizados",
  CUSTOMER: "Cliente",
  CUSTOMER_CONTRIBUTION: "Contribuci\xF3n de Cliente",
  CUSTOMER_CONTRIBUTION_IS_REQUIRED: "Contribuci\xF3n del Cliente es obligatorio.",
  CUSTOMER_CREATED_SUCCESSFULLY: "Cliente creado con \xE9xito",
  CUSTOMER_DETAILS: "Datos de Cliente",
  CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: "Detalles del cliente actualizados correctamente",
  CUSTOMER_INFORMATION: "Informaci\xF3n al cliente",
  CUSTOMER_INFORMATION_IS_REQUIRED: "Se requiere informaci\xF3n del cliente.",
  CUSTOMER_INVALID: "El cliente no se ha encontrado o creado, por favor, la b\xFAsqueda de un cliente",
  CUSTOMER_NAME: "Nombre de Cliente",
  CUSTOMER_NAME_IS_REQUIRED: "Se requiere informaci\xF3n del cliente.",
  CUSTOMER_NOT_FOUND: "Cliente No Encontrado",
  CUSTOMER_PROFILE: "Perfil del Cliente",
  CUSTOMER_REQUIRED: "Cliente requerido",
  CUSTOMER_RESOLUTION: "Resoluci\xF3n del Cliente",
  CUSTOMER_RESOLUTION_IS_REQUIRED: "Resoluci\xF3n del Cliente es obligatorio.",
  CUSTOMER_SEARCH: "B\xFAsqueda de Cliente",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Cliente actualizado correctamente",
  DAMAGED_MACHINES_HELP_TEXT: "En cuanto a las m\xE1quinas da\xF1adas, la garant\xEDa se suspender\xE1 autom\xE1ticamente hasta que el TCSM (Gerente de Soporte al Cliente de Territorio) revise y apruebe este formulario para restablecerla. Las m\xE1quinas da\xF1adas solo califican para Programas Obligatorios y PIP de Seguridad.",
  DATE: "Fecha",
  DATE_FORMAT: "Formato de Fecha",
  DATE_ISSUED: "Fecha Emitida",
  DATE_OF_CERTIFIED_LETTER: "Fecha de la Carta Certificada",
  DATE_OF_EVENT_CAUSING_DAMAGE: "Fecha del evento que provoc\xF3 el da\xF1o",
  DATE_OF_LAST_PERSONAL_CONTACT: "Fecha del \xFAltimo contacto personal",
  DATE_RECALLED_PART_WAS_SHIPPED_SENT: "Fecha en que la pieza retirada fue enviada/enviada",
  DATE_REFUSED: "Fecha de Denegaci\xF3n",
  DATE_SUBMITTED: "Fecha de env\xEDo",
  DAYS_FROM_REGISTRATION: "D\xEDas desde el Registro",
  DAYS_LEFT: "D\xEDas Restantes",
  DAYS_LEFT_WITH_COUNT: "{daysToDisplay} {days, plural, one {D\xEDa restante} other {D\xEDas restantes}}",
  DAYS_ON_RENT: "D\xEDas Alquilado",
  DAYS_REMAINING: "D\xEDas Restantes",
  DAYS_REMAINING_WITH_COUNT: "{daysToDisplay} {days, plural, one {Day} other {Days}} Restantes",
  DAYS_TO_DISPLAY: "D\xEDas para Mostrar",
  DBS: "DBS",
  DEALER: "Concesionario",
  DEALER_ACCOUNT: "Cuenta de concesionario",
  DEALER_ACCOUNT_IS_REQUIRED: "Cuenta del Concesionario es obligatorio.",
  DEALER_ACCOUNTS: "Cuentas de concesionario",
  DEALER_CITY: "Ciudad de Concesi\xF3n",
  DEALER_COMMENTS: "Comentarios del concesionario",
  DEALER_CONTRIBUTION: "Contribuci\xF3n de Concesi\xF3n",
  DEALER_CONTRIBUTION_IS_REQUIRED: "Contribuci\xF3n del Concesionario es obligatorio.",
  DEALER_HIERARCHY_ACCOUNT: "{account} ({industryIndicator})",
  DEALER_INVOICE_NUMBER: "N\xFAmero de Factura del Concesionario",
  DEALER_INVOICE_UPDATED: "Factura del Concesionario Actualizada",
  DEALER_INVOICE_UPDATES: "Factura del Concesionario",
  DEALER_INVOICES: "Facturas del Concesionario",
  DEALER_LOCATION: "Ubicaci\xF3n del Concesionario",
  DEALER_LOCATION_FILTER: "Ubicaciones de los Filtros",
  DEALER_LOCATION_IS_REQUIRED: "Ubicaci\xF3n del Concesionario es obligatorio.",
  DEALER_LOCATIONS: "Ubicaciones del Concesionario",
  DEALER_NAME: "Nombre del distribuidor",
  DEALER_PHONE: "N\xBA de Tel\xE9fono de Concesi\xF3n",
  DEALER_POSTAL_CODE: "C\xF3digo postal",
  DEALER_RECOMMENDATIONS: "Recomendaciones del concesionario",
  DEALER_RECOMMENDATIONS_TAB: "Recomendaciones del concesionario ({count})",
  DEALER_REVIEW_REQUEST_SUCCESSFULLY: "Concesionario revisado con \xE9xito",
  DEALER_SEARCH: "B\xFAsqueda de Concesionario",
  DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: "Ingresar Nombre, Ciudad o Cuenta para buscar concesionarios",
  DEALER_STATE: "Estado/Provincia de Concesi\xF3n",
  DEALER_SUBMISSION_WITH_CURRENCY: "Env\xEDo del Concesionario ({currency})",
  DEALER_TRANSFER_HISTORY: "Historial de transferencia de distribuidores",
  DEALER_TRANSFER_REQUEST_SUCCESSFULLY: "Solicitud de transferencia del concesionario en cola correctamente",
  DEALER_WARRANTY: "Garant\xEDa del Concesionario",
  DEALERS: "Concesionarios",
  DEALERSHIP: "Concesionario",
  DEBIT: "D\xE9bito",
  DEBIT_AMOUNT: "Cantidad del D\xE9bito",
  DEBIT_FOR_CLAIM_NUMBER: "D\xE9bito para {claimNumber}",
  DEBIT_REQUIRED: "D\xE9bito requerido",
  DEBIT_REQUIRED_STATUS: "Estado de D\xE9bito Requerido",
  DEBIT_SUBMITTED_SUCCESSFULLY: "D\xE9bito enviado con \xE9xito",
  DEBIT_TYPE: "Tipo de D\xE9bito",
  DEBITED: "Debitado",
  DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: "Los d\xE9bitos para esta reclamaci\xF3n deben ser completados mediante el proceso de d\xE9bito manual",
  DECIMAL_FORMAT: "Formato Decimal",
  DECISION_UPDATED: "Decisi\xF3n actualizada",
  DECLINE: "Rechazar",
  DEDUCTIBLE: "Franquicia",
  DEERE_REMARKS: "Comentarios de Deere",
  DEFAULT_WARRANTY: "Garant\xEDa Predeterminada",
  DEL: "Borrar",
  DELETE: "Borrar",
  DELETE_ATTACHMENT: "Eliminar adjunto",
  DELETE_CLAIM: "Eliminar reclamo",
  DELETE_REGISTRATION: "Eliminar Registro",
  DELETE_REGISTRATION_SUCCESS: "Registro Eliminar con \xE9xito",
  DELETED: "Eliminado",
  DELETED_BY: "Eliminado por",
  DELIVERED: "Entregado",
  DELIVERED_IS_REQUIRED: "Entregado es requerido.",
  DELIVERY_DATE: "Fecha de entrega",
  DELIVERY_DATE_REQUIRED: "Fecha de entrega es requerido.",
  DELIVERY_DATES: "Fechas de Entrega",
  DELIVERY_NO_DOCUMENTS: "Entrega Sin Documentos",
  DEMO_RENTAL_BEGIN_DATE: "Fecha de Incio de Alquiler/Demostraci\xF3n",
  DEMO_RENTAL_CHOOSE_DEALERS_STATUS: "Seleccionar Concesionarios y Estado",
  DEMO_RENTAL_END_DATE: "Fecha de Finalizaci\xF3n de Alquiler/Demostraci\xF3n",
  DEMO_RENTAL_HISTORY: "Historial de Renta Demostraci\xF3n",
  DENY: "Negar",
  DENY_MACHINE_STATUS_UPDATE: "Actualizaci\xF3n de estado de la m\xE1quina de denegaci\xF3n",
  DENY_PIP_CODE_REQUEST: "Negar Solicitud de c\xF3digo PIP",
  DESCENDING: "Descendente",
  DESCRIPTION: "Descripci\xF3n",
  DESCRIPTION_OF_DAMAGE: "Descripci\xF3n del da\xF1o",
  DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: "Descripci\xF3n del evento que provoc\xF3 el da\xF1o",
  DESELECT_ALL: "Deseleccionar todo",
  DETAILS: "Detalles",
  DIAGNOSTICS_COVERED: "Diagn\xF3stico Cubierto",
  DIS_VSR: "Mostrar mensajes",
  DISPLAY: "Mostrar",
  DISPLAY_CLAIM: "Mostrar Reclamaci\xF3n",
  DISPLAY_CREDIT_MEMO: "Mostrar Nota de Cr\xE9dito",
  DISPLAY_FORMAT: "Mostrar Formato",
  DISPLAY_PRODUCT: "Mostrar producto",
  DISPLAY_TAG: "Mostrar Etiqueta",
  DISTANCE: "Distancia",
  DISTANCE_FROM_CURRENT_DEALER: "Distancia desde el concesionario actual",
  DISTANCE_FROM_POTENTIAL_DEALER: "Distancia desde el concesionario potencial",
  DIVISION: "Divisi\xF3n",
  DIVISION_SUMMARY: "Resumen de la Divisi\xF3n",
  DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: "\xBFDesea guardar los cambios?",
  DOES_NOT_CONTAIN: "No contiene",
  DOWNLOAD_TO_EXCEL: "Descargar a Excel",
  DOWNTIME: "Tiempo de inactividad",
  DOWNTIME_IS_REQUIRED: "Tiempo de inactividad es obligatorio",
  DRAFT: "Guardar como Borrador",
  DTAC_CASE: "Caso DTAC",
  DTAC_CASE_NUMBER: "N\xFAmero de Caso DTAC",
  DTAC_SOLUTION: "Soluci\xF3n DTAC",
  DUE_DATE: "Fecha de vencimiento",
  DUE_WITHIN_3_MONTHS: "Esperado Dentro de los 3 Meses",
  DUPLICATE_PIN_PLATE: "Placa de PIN duplicada",
  DUPLICATE_PIN_PLATE_REQUEST_UPDATED: "Solicitud de placa de PIN duplicada actualizada",
  DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: "Solicitud de placa de PIN duplicada creada correctamente",
  DUPLICATE_PIN_PLATE_WITH_COUNT: "Solicitud de placa de PIN duplicada ({count})",
  EDIT: "Editar",
  EDIT_CUSTOMER: "Editar Cliente",
  EDIT_LAYOUT: "Editar Dise\xF1o de p\xE1gina",
  EDIT_WITH_PARENTHESES: "(Editar)",
  EFFECTIVE: "Eficaz",
  EFFECTIVE_DATE: "Fecha de vigencia",
  EMAIL: "Correo electr\xF3nico",
  EMISSIONS_PART_SEARCH: "B\xFAsqueda de Pieza de Emisiones",
  END_DATE: "Fecha de Finalizaci\xF3n",
  END_USE: "Uso Final",
  END_USE_CODE: "C\xF3digo de uso final",
  END_USE_CODE_REQUIRED: "Se requiere c\xF3digo de uso final",
  ENDS_WITH: "Termina con",
  ENGLISH: "Ingl\xE9s",
  ENTER_A_NUMBER_BETWEEN_0_AND_1000: "Ingrese un n\xFAmero entre 0 y 1000",
  ENTER_A_NUMBER_BETWEEN_0_AND_10000: "Ingrese un n\xFAmero entre 0 y 10000",
  ENTER_A_NUMBER_FROM_1_TO_9999: "Ingrese un n\xFAmero del 1 al 9999",
  ENTER_A_PART_NUMBER: "Ingrese un n\xFAmero de pieza",
  ENTER_COMMENTS_BEFORE_ACCEPTING: "Escriba los comentarios antes de aceptar",
  EQUALS: "Igual",
  ERROR: "ERROR:",
  ERROR_MESSAGE_TITLE: "Ocurri\xF3 un error:",
  ERROR_MESSAGES: "Mensaje de error",
  ERROR_MESSAGES_TITLE: "Ocurrieron varios errores:",
  ERROR_NETWORK_ISSUES: "Un error de red evit\xF3 que algunos datos se hayan cargado; int\xE9ntelo nuevamente.",
  ERROR_NO_DATA_TO_EXPORT: "No hay datos para exportar",
  ERROR_RETRIEVING_CUSTOMER_INFORMATION: "Error al recuperar la informaci\xF3n del cliente",
  ERROR_SAP: "No se puede conectar al servidor.  Si el problema contin\xFAa, utilice el enlace Cont\xE1ctenos para obtener asistencia para resolver su problema.",
  ERROR_SESSION: "Su sesi\xF3n ha expirado.  Actualice la p\xE1gina para volver a iniciar sesi\xF3n.",
  ERROR_UNHANDLED: "El sistema encontr\xF3 un error inesperado.  Si el problema contin\xFAa, utilice la funci\xF3n Ayuda o el enlace Cont\xE1ctenos para obtener asistencia para resolver su problema.",
  ERROR_UPLOADING_FILE: "No se a\xF1adi\xF3 el archivo",
  ESTIMATED_BASIC_DATE: "Fecha B\xE1sica Estimada",
  ESTIMATED_BASIC_DAYS: "D\xEDas B\xE1sicos Estimados",
  ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: "Puede que los presupuestos no reflejen el estado de demostraci\xF3n o las horas a\xFAn no reportadas.",
  EXCEEDS_DEMO_THRESHOLD: "Excede l\xEDmite de demostraci\xF3n",
  EXCHANGE_RATE: "Tasa de Cambio",
  EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: "Los PIN excluidos no se incluyen en este informe.",
  EXECUTE: "Ejecutar",
  EXPAND_ALL: "Expandir Todo",
  EXPECTED_FIRST_USE: "Primer Uso Esperado",
  EXPIRATION_DATE: "Fecha de Vencimiento",
  EXPIRED: "Expirado",
  EXPIRED_PART_REQUESTS: "Solicitudes de piezas caducadas",
  EXPIRED_PIPS: "PMP Expirados",
  EXPIRES: "Expiraci\xF3n",
  EXPIRING_SOON: "Fecha de expiraci\xF3n pr\xF3xima",
  EXPORT: "Exportar",
  EXTENDED_WARRANTY: "Garant\xEDa Extendida",
  FACTORY: "F\xC1BRICA",
  FACTORY_NAME: "Nombre de f\xE1brica",
  FAILED: "Se ha averiado",
  FAILED_AREA: "\xC1rea de falla",
  FAILED_AREA_IS_REQUIRED: "\xC1rea de Falla' es requerido.",
  FAILED_DATE: "Fecha de la Aver\xEDa",
  FAILED_DATE_IS_REQUIRED: "El campo Fecha de la Aver\xEDa es obligatorio.",
  FAILED_MODE: "Modo de Falla",
  FAILED_MODE_COMMENTS: "Comentarios del Modo de Falla",
  FAILED_PART: "Parte Averiada",
  FAILED_PART_DESCRIPTION: "Descripci\xF3n de la parte Averiada",
  FAILED_PART_IS_A_REMAN_PART: "Parte Averiada es una parte ReMan",
  FAILED_PART_IS_REQUIRED: "Parte averiada es requerido.",
  FAILED_PART_SERIAL: "N\xFAmero de Serie de la Parte Averiada",
  FAILED_PART_SERIAL_IS_REQUIRED: "No. de Serie de la Parte Averiada es requerido.",
  FAILURE_DATE: "Fecha de la aver\xEDa",
  FAILURE_INFORMATION: "Informaci\xF3n de la aver\xEDa",
  FAILURE_MODE: "Modo de Falla/o",
  FAILURE_MODE_IS_REQUIRED: "El campo Modo de Aver\xEDa es requerido.",
  FAILURE_PART: "Parte averiada",
  FAILURE_PART_DESCRIPTION: "Descripci\xF3n de la parte averiada",
  FAILURE_PART_IS_REQUIRED: "El campo 'Parte Averiada' es requerido.",
  FAILURE_TO_RETURN_PARTS_WARNING: "El no devolver los art\xEDculos solicitados puede resultar en un d\xE9bito.",
  FAVORITES: "Favoritos",
  FILE_NAME: "Nombre del Archivo",
  FILE_SIZE_IS_TOO_BIG: "El tama\xF1o del archivo es demasiado grande. (Tama\xF1o M\xE1ximo 100MB)",
  FILE_SIZE_IS_TOO_BIG_CSV: "El tama\xF1o del archivo es demasiado grande. (Tama\xF1o M\xE1ximo 1MB)",
  FILE_UPLOAD_MESSAGE: "Descargar archivos aqu\xED o haga clic para agregar archivos. (Tama\xF1o M\xE1ximo 100MB)",
  FILE_UPLOAD_MESSAGE_CSV: "Descargar archivos aqu\xED o haga clic para agregar archivos. (Tama\xF1o M\xE1ximo 1MB)",
  FILE_UPLOAD_MESSAGE_IMAGE: "Descargar imagen aqu\xED o haga clic para agregar imagen. (Tama\xF1o M\xE1ximo 100MB)",
  FILE_UPLOAD_MESSAGE_SINGLE: "Descargue solo un archivo aqu\xED o haga clic para agregar. (Tama\xF1o M\xE1ximo 100MB)",
  FILE_UPLOAD_UNABLE_TO_READ: "El sistema no pudo leer su archivo.  Comp\xE1relo con la plantilla e int\xE9ntelo de nuevo.",
  FILES: "Archivos",
  FILTER_PLACEHOLDER: "Filtrar Resultados",
  FILTER_WITH_ELLIPSIS: "Filtrar\u2026",
  FILTERED_BY_COLUMN_ID: "Filtrado por {columnId}",
  FIND_CUSTOMER: "Encontrar Cliente",
  FINNISH: "Finland\xE9s",
  FIRST_MAINTENANCE: "PRIMER MANTENIMIENTO",
  FIRST_NAME: "Nombre",
  FIRST_NAME_IS_REQUIRED: "El campo 'Nombre' es requerido.",
  FIRST_SHIP_TO_LOCATION: "Primer Env\xEDo a Ubicaci\xF3n",
  FIRST_USE: "Primer Uso",
  FISCAL_YEAR: "A\xF1o fiscal",
  FLUID_SAMPLING_REQUIRED: "Muestreo de Fluido Requerido",
  FORWARDED: "Transferida",
  FRENCH: "Franc\xE9s",
  FROM: "De",
  FRWRD: "Enviar",
  FULL_DEBIT: "D\xE9bito Completo",
  GENERAL: "General",
  GERMAN: "Alemana",
  GET_MAINTENANCE_PLANS: "Obtener Planes de Mantenimiento",
  GOODS_INSTALLATION_VAT: "IVA de la Instalaci\xF3n de Productos",
  GRACE_PERIOD: "Per\xEDodo de Gracias",
  GREATER_THAN: "Mayor que",
  GREATER_THAN_OR_EQUALS: "Mayor que o iguales",
  GROUP_COMPLETE: "Grupo Completo",
  GST_PERCENTAGE: "GST Porcentaje",
  HISTORY_TO_DISPLAY: "Mostrar Historial (d\xEDas)",
  HOME: "Casa",
  HOUR_LIMIT: "Hora l\xEDmite",
  HOURS: "Horas",
  HOURS_ON_RENT: "Horas en Alquiler",
  HSN_SAC_CODE: "HSN/SAC C\xF3digo",
  IGST: "IGST",
  IMPLEMENTS: "Aperos",
  IN_RANGE: "En el rango",
  INCENTIVE: "Incentivo",
  INCENTIVE_PROGRAMS: "Programas de incentivos",
  INCLUDE_FULLY_COMPLETE: "Incluir PIP completos",
  INDICATES_REQUIRED_FIELD: "Indica que el campo es requerido",
  INFO_MESSAGE_TITLE: "Se envi\xF3 una notificaci\xF3n del sistema:",
  INFO_MESSAGES: "Mensajes de Informaci\xF3n",
  INFO_MESSAGES_TITLE: "Se enviaron varias notificaciones del sistema:",
  INFO_REQUEST_STATUS_ERROR: "La informaci\xF3n est\xE1 lista para ser presentada con esta solicitud.",
  INFORMATION: "Informaci\xF3n",
  INFORMATION_REQUEST: "Solicitud de informaci\xF3n",
  INFORMATION_REQUEST_STATUS: "Estado de solicitud de informaci\xF3n",
  INPUT_PIN: "Introduzca NIP",
  INSPECTION: "Inspecci\xF3n",
  INSTALLED_BY: "Instalado por",
  INSTALLED_BY_IS_REQUIRED: "El campo Instalado Por es obligatorio.",
  INTERNAL_DEERE_COMMENTS: "Comentarios Internos de Deere",
  INTERVAL_BEGINS: "El Intervalo Comienza",
  INTERVAL_ENDS: "El Intervalo Finaliza",
  INTERVAL_TYPE_DESCRIPTION: "Descripci\xF3n del Tipo de Intervalo",
  INVOICE_ACCOUNT: "Cuenta de Facturaci\xF3n",
  INVOICE_DEALER: "Facturar Concesi\xF3n/Distr.",
  INVOICE_NUMBER: "N\xBA de Factura",
  INVOICE_REQUEST: "Solicitud de Factura",
  INVOICE_SENT: "Factura Enviada",
  INVOICE_UPDATED_SUCCESSFULLY: "Factura actualizado con \xE9xito",
  INVOICED: "Facturado",
  INVOICED_TO: "Facturado a",
  IRC_PIN_MESSAGE: "El cliente es un IRC y tiene derecho a un tiempo de traslado y kilometraje gratuitos durante las primeras 500 horas o 12 meses de propiedad de la m\xE1quina.",
  ISSUED: "Emitida",
  ITALIAN: "Italiano",
  ITEM: "\xEDt",
  ITEM_NUMBER: "N\xFAmero de Art\xEDculo",
  ITEM_NUMBER_IS_REQUIRED: "N\xFAmero de art\xEDculo es requerido.",
  JDLINK_EXPIRES: "Expira JDLink",
  JDP_COMMENTS: "Comentarios de JDP",
  JDP_COMMENTS_IS_REQUIRED: "El campo Comentarios de JDP es requerido.",
  JDP_CUSTOMER_RESOLUTION: "Resoluci\xF3n del cliente de JDP",
  JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: "El campo Resoluci\xF3n del Cliente de JDP es requerido.",
  JDP_REASON: "Motivo de JDP",
  JDP_REASON_IS_REQUIRED: "El campo Motivo de JDP es requerido.",
  LABOR: "Mano de obra",
  LABOR_ADDITIVE: "Suplemento de mano de obra",
  LABOR_ADDITIVE_COMPLETION_DETAIL: "Detalles de la terminaci\xF3n del suplemento de mano de obra",
  LABOR_ADDITIVE_PIPS: "PIP del suplemento de mano de obra",
  LABOR_ADDITIVE_TAB: "Suplementario de Mano de Obra ({count})",
  LABOR_ADJUSTMENT: "Ajuste de la Mano de Obra",
  LABOR_COMMENTS: "Comentarios de Mano de obra",
  LABOR_HOURS: "Mano Obra",
  LABOR_ITEM_DETAILS: "Mano de obra - {quantity} {unit} {description}",
  LABOR_RATE_APPROVED_SUCCESSFULLY: "Tarifa de Mano de Obra Aprobada Satisfactoriamente",
  LABOR_RATE_CHANGE_SUBMITTED: "Modificaci\xF3n del Costo Laboral Enviada",
  LABOR_RATE_CHANGES_WITH_COUNT: "Cambios de tarifa de mano de obra ({count})",
  LABOR_RATE_CONFIRM: "La tarifa solicitada es inferior a la tarifa actual.  \xBFEst\xE1 seguro de que desea enviar la solicitud?",
  LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: "Las proporciones en el texto rojo indican un aumento de m\xE1s del 10% con respecto a la dosis existente",
  LABOR_RATE_HISTORY: "Historial de la tarifa de mano de obra",
  LABOR_RATE_REJECTED_SUCCESSFULLY: "Tarifa de Mano de Obra Rechazada Satisfactoriamente",
  LABOR_RATE_REQUESTS_STATUS: "Estado de solicitudes de tarifas de mano de obra",
  LABOR_RATE_RETURNED_SUCCESSFULLY: "Tarifa de Mano de Obra Devuelta Correctamente",
  LABOR_RATES: "Tarifa de mano de obra",
  LABOR_STATS: "Estad\xEDsticas de mano de obra",
  LABOR_TOTAL: "Mano de obra total",
  LABOR_TYPE: "Tipo de mano de obra",
  LABOR_VALUE: "Valor de Mano de Obra",
  LABOR_WITH_COUNT: "Mano de Obra ({count})",
  LANGUAGE: "Idioma",
  LAST_LOCATION_FROM: "\xDAltima ubicaci\xF3n desde",
  LAST_NAME: "Apellido",
  LAST_NAME_IS_REQUIRED: "El campo Apellido es requerido.",
  LAST_PERSONAL_CONTACT: "\xDAltimo Contacto Personal",
  LAW_ENFORCEMENT_AGENCY_DETAILS: "Detalles de la Agencia de Cumplimiento de la Ley",
  LAYOUT_CREATED_SUCCESSFULLY: "Dise\xF1o de p\xE1gina creado con \xE9xito",
  LAYOUT_DELETED_SUCCESSFULLY: "Dise\xF1o de p\xE1gina eliminado exitosamente",
  LAYOUT_NAME: "Nombre del dise\xF1o de p\xE1gina",
  LAYOUT_UPDATED_SUCCESSFULLY: "Dise\xF1o de p\xE1gina actualizado con \xE9xito",
  LEAD_ACCOUNT: "Cuenta Principal",
  LEAD_DEALER: "Concesionario Principal",
  LESS_THAN: "menor que",
  LESS_THAN_OR_EQUALS: "menor o igual que",
  LICENSE_PLATE_NUMBER: "No. de placa o No. de matr\xEDcula",
  LIFETIME: "De por vida",
  LINE_ITEMS_EXPORT: "Exportaci\xF3n de art\xEDculos de l\xEDnea",
  LIST: "Lista",
  LIST_TOTAL: "Lista Total",
  LOCATION: "Ubicaci\xF3n",
  LOCATION_DUE: "Ubicaci\xF3n Prevista",
  LOCATIONS: "Ubicaciones",
  LOCATIONS_WITH_COUNT: "Ubicaci\xF3n ({count})",
  MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: "La m\xE1quina ya est\xE1 registrada con este cliente.",
  MACHINE_INFORMATION: "Informaci\xF3n de M\xE1quina",
  MACHINE_MODEL_TYPE: "Modelo/tipo de m\xE1quina",
  MACHINE_MODEL_TYPE_REQUIRED: "Modelo/tipo de m\xE1quina requerido",
  MACHINE_STATUS: "Estatus de M\xE1quina",
  MACHINE_STATUS_UPDATE_ACCEPTED: "Actualizaci\xF3n de Estado de M\xE1quina Aprobada",
  MACHINE_STATUS_UPDATE_DOCUMENT: "Documento de Actualizaci\xF3n de Estado de M\xE1quina",
  MACHINE_STATUS_UPDATE_REJECTED: "Actualizaci\xF3n de Estado de M\xE1quina Rechazada",
  MACHINE_STATUS_UPDATES_WITH_COUNT: "Actualizaciones del Estado de la M\xE1quina ({count})",
  MACHINE_TYPE: "Tipo de m\xE1quina",
  MACHINE_TYPE_IS_REQUIRED: "El campo Tipo de M\xE1quina es requerido.",
  MACHINE_USE: "Uso de M\xE1quina",
  MAILING_RECIPIENT: "Destinatario de correo (nombre y apellidos)",
  MAILING_RECIPIENT_REQUIRED: "Destinatario de correo requerido",
  MAINTENANCE: "Mantenimiento",
  MAINTENANCE_PLAN: "Planes de Mantenimiento",
  MAINTENANCE_PLAN_INFO: "Informaci\xF3n sobre el Plan de Mantenimiento",
  MARK_AS_REVIEW: "Marcar como revisado",
  MARKETING_INCENTIVE: "Marketing: Incentivo",
  MARKETING_JD_PROMISE: "Marketing: Promesa de JD",
  MARKETING_MAINTENANCE_PLAN: "Marketing: Plan de mantenimiento",
  MARKETING_MASS_CHANNEL_FOLLOWUP: "Marketing: Seguimiento de Canales en Masa",
  MARKETING_MASS_CHANNEL_PDI: "Marketing: PDI de Canales en Masa",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP: "Seguimiento de Cliente de Canal en Masa",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: "Recordatorio: Aseg\xFArese de ponerse en contacto con su propio asesor legal a fin de determinar los procedimientos de #No Llamar# adecuados para su estado y a nivel federal antes de implementar el Programa de Seguimiento con Llamadas Posteriores a la Venta.",
  MASS_CHANNEL_PDI_CLAIM: "PDI de Canal en Masa",
  MASTER_WARRANTY_TYPE: "Tipo de garant\xEDa principal",
  MATERIAL: "N\xFAmero de material",
  MERCHANDISE: "Mercanc\xEDa",
  MESSAGE: "Mensaje",
  MESSAGES: "Mensajes",
  METHOD_OF_CONTACT: "M\xE9todo de contacto",
  METHOD_OF_CONTACT_IS_REQUIRED: "El campo M\xE9todo de Contacto es requerido.",
  METRIC: "Criterios de Evaluaci\xF3n",
  METRICS: "M\xE9tricas",
  MILEAGE_LIMIT: "L\xEDmite de Millaje",
  MOBILE_PHONE: "Tel\xE9fono m\xF3vil",
  MODEL: "Modelo",
  MODEL_NUMBER: "N\xFAmero de modelo",
  MODIFIED: "Modificado",
  MONTH_TO_DATE: "Mes Actual",
  MORE: "M\xE1s",
  MULTIPLE: "M\xFAltiple",
  NAME: "Nombre",
  NET: "Neto",
  NET_AMOUNT: "Monto Neto",
  NET_AMOUNT_PAID: "Monto neto pagado",
  NET_TOTAL: "Neto Total",
  NEW: "Nuevo",
  NEW_ACCOUNT: "Nueva Cuenta",
  NEW_CLAIM: "Nueva Reclamaci\xF3n",
  NEW_CLAIM_VALUE: "Nuevo Valor de Reclamaci\xF3n",
  NEW_CUSTOMER_REQUIRED: "El campo Cliente Nuevo es requerido",
  NEW_DEALER: "Concesionario/Distr Nuevo",
  NEW_DEALER_DISTANCE: "Distancia de concesionario nuevo",
  NEW_DEALER_LOCATION: "Nueva Ubicaci\xF3n del Concesionario",
  NEW_LABOR_RATE: "Nueva Tarifa de Mano de Obra",
  NEW_REQUEST_ENTER_RATES: "Solicitud nueva - Introducir dosis",
  NEW_STATUS: "Nuevo estatus",
  NEW_TRANSFER: "Nueva Transferencia",
  NEW_TRANSFER_CREATED: "Nueva Transferencia Creada",
  NEW_VALUE: "Valor Nuevo",
  NO: "No",
  NO_ACTIVE_WARRANTY: "Sin garant\xEDa activa",
  NO_AFFECTED_PINS: "No hay NIPs afectados bajo responsabilidad de su concesionario.",
  NO_AUTHORITY_TO_ACCESS: "Usted no tiene autoridad para acceder al JDWS. Los usuarios del concesionario deben consultar al Administrador de perfiles (DPA) para verificar la autoridad y los usuarios de Deere se comunican con el servicio de asistencia con una copia de este error aqu\xED",
  NO_CLAIMS: "No hay reclamaciones.",
  NO_CUSTOMER_ASSOCIATED: "No hay Clientes Asociados",
  NO_CUSTOMER_SELECTED: "No se seleccion\xF3 Ning\xFAn Cliente",
  NO_DEALER_INVOICES: "No hay Facturas del Concesionario.",
  NO_DEALERS_MAPPED: "No hay concecionarios asignados a su ID de usuario. Por favor contacte a su administrador de sistemas.",
  NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: "No (Si la respuesta es no, debe proporcionarse una imagen como evidencia)",
  NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: "Informaci\xF3n no disponible para este producto",
  NO_LOWERCASE: "No",
  NO_MATCHING_DEALERS: "Ning\xFAn concesionario coincide con el texto del filtro.",
  NO_OPEN_PART_REQUESTS: "No hay solicitudes de partes abiertas",
  NO_OPEN_PIPS: "No hay PIP abiertos",
  NO_PARTS_RETURNED: "Partes no devueltas",
  NO_PIP_PRODUCTS: "No hay productos PIP.",
  NO_PRODUCT_FOUND: "No se encontr\xF3 producto.",
  NO_REQUIRED_ITEMS: "No hay elementos requeridos.",
  NO_RESULTS: "Sin resultados",
  NO_RESULTS_FOUND: "No se Encontraron Resultados.",
  NO_ROWS_TO_SHOW: "No hay lineas para monstrar.",
  NO_SPECIAL_INSTRUCTIONS: "No hay instrucciones especiales.",
  NO_TRAVEL: "No se reembolsan costos de vi\xE1ticos",
  NON_RECOVERABLE_TAXES: "Impuestos No Recuperables",
  NON_TRACKED_PINS_HELP_TEXT: "Algunos productos no aparecen en la Garant\xEDa hasta despu\xE9s del registro. La b\xFAsqueda coincide con varios de estos productos.",
  NON_TRAVEL: "Sin Viaje",
  NONE: "Ning\xFAn",
  NORMAL: "NORMAL",
  NOT_EQUAL: "No es igual",
  NOTIFICATION_ADDED_SUCCESSFULLY: "Notificaci\xF3n agregada correctamente",
  NOTIFICATION_DELETED_SUCCESSFULLY: "Notificaci\xF3n eliminada correctamente",
  NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: "Secuencia de notificaci\xF3n actualizada correctamente",
  NOTIFICATION_UPDATED_SUCCESSFULLY: "Notificaci\xF3n exitosamente Actualizado",
  NOTIFICATIONS: "Notificaciones",
  NUMBER_OF_DIAGNOSTICS_OCCURRENCES: "Cantidad de Instancias de Diagn\xF3stico",
  NUMBER_OF_OPEN_PIPS: "{number} Pips abiertos",
  NUMBER_OF_REPAIR_OCCURRENCES: "Cantidad de Instancias de Reparaci\xF3n",
  NUMBER_OF_REPLACEMENT_OCCURRENCES: "Cantidad de Instancias de Reemplazo",
  OLD_LABOR_RATE: "Tarifa de Mano de Obra Anterior",
  ON_SHELF: "En almac\xE9n",
  ON_SHELF_COST: "Costo de Almacenaje",
  ONE_ITEM_MUST_BE_SELECTED: "Se debe seleccionar un elemento.",
  OPEN: "Abiertas",
  OPEN_PART_REQUESTS: "Solicitudes de Partes Abiertas",
  OPEN_PART_REQUESTS_WITH_COUNT: "Solicitudes de Partes Abiertas ({count})",
  OPEN_PIP_COUNT: "Recuento de PIP abierto",
  OPEN_PIP_PROGRAMS: "Registro de PMP",
  OPEN_PIPS: "PIPs abiertos/ vigentes",
  OPEN_PIPS_REPORT: "Informe de Programa de Mejoras sin Terminar",
  OPEN_PIPS_TAB: "PIPs abiertos/ vigentes ({count})",
  OPERATORS_COMPLAINT: "\xBFCu\xE1l fue la reclamaci\xF3n del operador?",
  OPERATORS_COMPLAINT_IS_REQUIRED: "El campo Reclamaci\xF3n del Operador es requerido.",
  OPERATORS_MANUAL_NUMBER: "N\xBA de Manual de Operador",
  OPTION_CODE: "C\xF3digo de Opci\xF3n",
  OPTION_CODE_CREATED_SUCCESSFULLY: "C\xF3digo de Opci\xF3n creado satisfactoriamente",
  OPTION_CODE_DELETED_SUCCESSFULLY: "C\xF3digo de Opci\xF3n borrado satisfactoriamente",
  OPTION_CODES: "C\xF3digo de Opciones",
  OR: "o",
  ORIGINAL_CLAIM_VALUE: "Valor de reclamaci\xF3n original",
  ORIGINAL_SUBMISSION_DATE: "Fecha Original de Env\xEDo",
  ORIGINALLY_SUBMITTED: "Originalmente enviado/sometido",
  OTHER: "Otro",
  OTHER_AMOUNT_OF_USE: "Otras horas de uso",
  OTHER_AMOUNT_OF_USE_REQUIRED: "El campo 'otras horas de uso' es requerido ",
  OTHER_CREDIT: "Otro cr\xE9dito",
  OTHER_CREDIT_1: "Otro cr\xE9dito 1",
  OTHER_CREDIT_2: "Otro cr\xE9dito 2",
  OTHER_CREDIT_3: "Otro cr\xE9dito 3",
  OTHER_CREDIT_ADJUSTMENT: "Otro ajuste de cr\xE9dito",
  OTHER_CREDIT_ITEM_DETAILS: "Otro cr\xE9dito - {description} ({quantity} {unit})",
  OTHER_CREDIT_TOTAL: "Total de Otros Cr\xE9ditos",
  OTHER_CREDITS: "Otros Cr\xE9ditos",
  OTHER_CREDITS_WITH_COUNT: "Otros Cr\xE9ditos ({count})",
  OTHER_INSTRUCTIONS: "Otras instrucciones",
  OUTPUT_PIN: "Resultado de No. de serie o NIP",
  OVERDUE: "Vencidas",
  OVERRIDE_ACCOUNT: "Anular cuenta",
  OVERRIDE_EFFECTIVE_DATE: "Fecha de vigencia anulada",
  OVERRIDE_SUGGESTED_ACCOUNT: "Anular cuenta sugerida",
  OWNERSHIP_STATUS: "Estado del Propietario",
  OWNERSHIP_STATUS_IS_REQUIRED: "El campo 'Estado de Propietario' es requerido.",
  PART: "Parte",
  PART_1: "Parte 1",
  PART_2: "Parte 2",
  PART_3: "Parte 3",
  PART_4: "Parte 4",
  PART_5: "Parte 5",
  PART_6: "Parte 6",
  PART_7: "Parte 7",
  PART_8: "Parte 8",
  PART_9: "Parte 9",
  PART_10: "Parte 10",
  PART_AMONT_OF_USE: "Cantidad de uso de la parte",
  PART_FAMILY: "Familia de la parte",
  PART_ITEM_DETAILS: "Partes - {quantity} {description} N\xFAmero de parte {partNumber}",
  PART_NUMBER: "N\xFAmero de parte",
  PART_REQUEST: "Solicitud de Pieza",
  PART_REQUEST_NUMBER: "N\xFAmero de solicitud de parte {rgaNumber}",
  PART_REQUEST_STATUS: "Estado de la Solicitud de Partes",
  PART_REQUESTS: "Solicitudes de partes",
  PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: "Ingrese un N\xFAmero de Reclamo; m\xEDnimo de 4 caracteres",
  PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: "La b\xFAsqueda de reclamaciones debe ser de al menos 4 caracteres.",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: "La b\xFAsqueda de N\xFAmero de Caso DTAC debe ser el N\xFAmero de Caso DTAC completo; al menos 4 caracteres.",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: "Ingrese un N\xFAmero de Caso DTAC completo.",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: "El N\xFAmero de Parte debe tener al menos 4 caracteres.",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: "Ingrese N\xFAmero de Parte; m\xEDnimo 4 caracteres.",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: "La b\xFAsqueda de N\xFAmero de Solicitud de Parte debe ser al menos 4 caracteres.",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: "Ingrese N\xFAmero de Solicitud de Parte; m\xEDnimo  4 caracteres.",
  PART_REQUESTS_SEARCH_BY_PIN_ERROR: "La B\xFAsqueda de PIN/NIP debe ser de al menos 4 caracteres.",
  PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: "Ingrese un NIP; m\xEDnimo de 4 caracteres.",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: "La b\xFAsqueda de Orden de Trabajo debe ser una Orden de Trabajo completa; al menos 2 caracteres.",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: "Ingrese una Orden de Trabajo completa.",
  PART_REQUESTS_UPDATED_SUCCESSFULLY: "Solicitud de Parte actualizada correctamente",
  PART_RETURN: "Devoluci\xF3n de Parte",
  PART_RETURNS: "Devoluci\xF3n de Partes",
  PART_SERIAL_NUMBER: "N\xFAmero de Serie de la Parte",
  PART_SERIAL_NUMBER_IS_REQUIRED: "El campo N\xFAmero de Serie de la Parte es requerido.",
  PART_TOTAL: "Total de partes",
  PART_TYPE: "Tipo de parte",
  PART_USE: "Uso de la parte",
  PART_VALUE: "Valor de la parte",
  PARTIAL_DEBIT: "D\xE9bito Parcial",
  PARTICIPANT: "Participante",
  PARTS: "Partes",
  PARTS_ADDITIVE: "Suplemento de partes",
  PARTS_ADJUSTMENTS: "Ajuste de piezas",
  PARTS_COVERAGE_SEARCH: "B\xFAsqueda de cobertura de partes",
  PARTS_TEMPLATE: "Plantilla de piezas",
  PARTS_USE: "Uso de las partes",
  PARTS_USE_IS_REQUIRED: "El campo 'Uso de la parte' es obligatorio.",
  PARTS_WITH_COUNT: "Partes ({count})",
  PARTS_WITH_PARENTHESES: "Parte(s)",
  PAST_DUE: "Vencido(a)",
  PAYER_ACCOUNT: "Cuenta del Pagador",
  PERCENT_COMPLETE: "Porcentaje completo",
  PERCENTAGE: "Porcentaje",
  PERCENTAGE_DEBIT: "D\xE9bito porcentual",
  PERCENTAGE_SYMBOL: "{percentage}%",
  PERCENTAGE_TO_DEBIT: "Porcentaje para D\xE9bito",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: "Para las m\xE1quinas que se encuentran permanentemente fuera de servicio, incluya una imagen de la m\xE1quina para verificar que esta no se puede reconstruir, ni reparar ni utilizar en el futuro. Las m\xE1quinas que se encuentran permanentemente fuera de servicio no califican para ninguna clase de Programa de Mejoramiento de Productos (PIP).",
  PERSON_RESPONSIBLE: "Persona responsable",
  PHONE: "Tel\xE9fono",
  PHONE_REQUIRED: "Tel\xE9fono requerido",
  PICTURE: "Imagen",
  PICTURE_REQUEST: "Solicitud de imagen",
  PICTURE_REQUEST_STATUS: "Estado de solicitud de imagen",
  PICTURE_REQUEST_STATUS_ERROR: "Los archivos adjuntos est\xE1n listos para ser enviados con esta solicitud.",
  PIN: "N\xFAmeros de serie",
  PIN_CREATED_SUCCESSFULLY: "NIP/N\xFAmero de serie creado correctamente",
  PIN_CROSS_REFERENCE: "Referencia cruzada de N\xFAmero de Serie",
  PIN_INVALID: "NIP/N\xFAmero de serie no v\xE1lido",
  PIN_IS_REQUIRED: "El NIP/N\xFAmero de serie es requerido",
  PIN_REQUIRED: "El NIP/N\xFAmero de serie es requerido",
  PIN_SEARCH: "B\xFAsqueda de pasadores",
  PIN_SEARCH_INFORMATION: "Informaci\xF3n de b\xFAsqueda de pasadores",
  PIN_TRANSFER_INFORMATION: "Informaci\xF3n de transferencia de pasadores",
  PINS: "PIN",
  PINS_NOT_REGISTERED: "N\xBA de serie no esta registrado",
  PIP: "Programa",
  PIP_CODE: "C\xF3digo de Programa de Mejora del Producto",
  PIP_CODE_CREATED_SUCCESSFULLY: "Solicitud de c\xF3digo de programa de mejora del producto (PIP) creado correctamente",
  PIP_CODE_REQUEST: "Solicitud de c\xF3digo PMP",
  PIP_CODE_REQUEST_APPROVED: "Solicitud de C\xF3digo PMP Aprobada",
  PIP_CODE_REQUEST_REJECTED: "Solicitud de C\xF3digo PMP Rechazada",
  PIP_CODE_REQUESTS_WITH_COUNT: "Solicitudes de C\xF3digo PMP ({count})",
  PIP_COMPLETION_STATUS: "Estatus de Finalizaci\xF3n de PMP",
  PIP_DETAILS: "Detalles del PMP",
  PIP_HISTORY: "Historial de PMP",
  PIP_ID: "N.\xBA de PMP",
  PIP_NUMBER: "N\xBA de Programa de Mejora del Producto",
  PIP_PROGRAM: "Programa de Mejora del Producto (PMP)",
  PIP_PROGRAM_IS_REQUIRED: "El campo Programa de Mejora del Producto (PIP) es obligatorio.",
  PIP_PROGRAMS: "Programas PMP",
  PIP_SEARCH: "Buscar PMP",
  PIP_STATUS: "Estado de PMP",
  PIP_TYPE: "Tipo de PMP",
  PIP_TYPES: "Tipos de PMP",
  PIPS: "PMP- Programa de Mejora del Producto",
  PIPS_UNPAID_LABOR_ADDITIVE: "Prima por mano de obra de PMP",
  PLAN_DESCRIPTION: "Descripci\xF3n del Plan",
  PLAN_END_DATE: "Fecha de Finalizaci\xF3n del Plan",
  PLAN_ENDS: "Plan finaliza",
  PLAN_NAME: "Nombre del Plan",
  PLAN_NAME_IS_REQUIRED: "El campo Nombre del Plan es requerido.",
  PLAN_NAMES: "Nombres del Plan",
  PLAN_START_DATE: "Fecha de Inicio del Plan",
  PLAN_STARTS: "Inicia el plan",
  PLANNED_BY: "Planificado por",
  PLANT: "Planta",
  PLATE_REQUEST_INFORMATION: "Informaci\xF3n de solicitud de placa",
  PLEASE_SELECT_A_LEAD_ACCOUNT: "Seleccione una cuenta principal",
  PLEASE_SELECT_CLAIM_TYPE: "Por favor seleccione el tipo de reclamo",
  POLISH: "Polaco",
  PORTUGUESE: "Portugu\xE9s",
  POSTAGE_DELIVERY_DATE: "Fecha de entrega de franqueo",
  POSTAL_CODE: "C\xF3digo postal",
  POSTAL_CODE_REQUIRED: "C\xF3digo postal requerido",
  POSTAL_TRACKING_NUMBER: "N\xFAmero de rastreo postal",
  POTENTIAL_RESPONSIBLE_DEALER: "Posible concesionario responsable",
  PRE_DELIVERY_INSPECTION: "Inspecci\xF3n de pre entrega",
  PREFERRED_THEME: "Tema Preferido",
  PREPARE_AUDIT: "Preparar la Auditor\xEDa",
  PREPARED: "Preparado",
  PREPARING_AUDIT_FOR_WITH_DEALER: "Preparando la auditor\xEDa para {dealer}",
  PREVIOUS_AMOUNT_OF_USE: "Cantidad anterior de horas utilizadas",
  PREVIOUS_INVOICE_NUMBER: "N\xFAmero de Factura Anterior",
  PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: "El n\xFAmero de la factura anterior es necesario.",
  PREVIOUS_MONTH: "Mes Anterior",
  PRICE: "Precio",
  PRICING_SUMMARY: "Resumen de Precios",
  PRIMARY_ACTION: "Acci\xF3n Principal",
  PRIMARY_LANGUAGE: "Idioma Principal",
  PRINT: "Imprimir",
  PRINT_CLAIM: "Imprimir Reclamaci\xF3n",
  PRINT_REGISTRATION_FORM: "Imprimir el formulario de registro",
  PRINT_REGISTRATION_FORM_MESSAGE: "La m\xE1quina est\xE1 registrada al propietario anterior. \xBFDesea imprimir el formulario de registro?",
  PRINT_TO_PDF: "Imprentar PDF",
  PRIORITY: "Prioridad",
  PRNT_CLM: "Mostrar Reclamaci\xF3n",
  PROCESS_DATE: "Fecha de Proceso",
  PROCESSED: "Procesado",
  PROCESSED_PART_REQUESTS: "Solicitudes de partes procesadas",
  PROCESSING_STATUS: "Estado de procesamiento",
  PROCESSING_STATUS_DESCRIPTION: "La descripci\xF3n del estado de procesamiento",
  PRODUCT_DETAILS: "Detalles del producto",
  PRODUCT_HIERARCHY: "Jerarqu\xEDa de productos",
  PRODUCT_INFORMATION: "Informe de producto",
  PRODUCT_REGISTERED: "Equipo Registrado",
  PRODUCT_REGISTRATION: "Registraci\xF3n del producto",
  PRODUCT_REGISTRATION_PENDED: "El registro esta pendiente",
  PRODUCT_TRACKING: "Rastro de Producto",
  PRODUCTS: "Productos",
  PRODUCTS_BY_CUSTOMER: "Productos por cliente",
  PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: "Los PIN hist\xF3ricos pueden faltar en los resultados de b\xFAsqueda debido a un problema temporal de conectividad del sistema.",
  PRODUCTS_WITH_COUNT: "Productos ({count})",
  PROGRAM: "Programa",
  PROGRAM_DESCRIPTION: "Descripci\xF3n del programa",
  PROGRAM_IS_REQUIRED: "El nombre del programa es obligatorio.",
  PROGRAM_NAME: "El nombre del programa",
  PROGRAM_NAME_IS_REQUIRED: "El nombre del programa es obligatorio.",
  PROGRAM_NUMBER: "N\xFAmero de programa",
  PRT: "Rastro de Producto",
  PRTS: "PRT",
  PURCHASE_INFO: "Informaci\xF3n de Compra",
  PURCHASE_ORDER: "Orden de Compra",
  PURCHASE_ORDER_IS_REQUIRED: "El orden de compra es necesario.",
  PURCHASER_TYPE: "Tipo de compradora",
  PURCHASER_TYPE_REQUIRED: "El tipo de comprador es necesario",
  PUSH_XML: "Volver a enviar XML",
  QTY: "Cantidad",
  QUALIFY_FOR_EMISSIONS: "Cumple los Requisitos de Emisiones",
  QUANTITY: "Cantidad",
  QUANTITY_1: "Cantidad 1",
  QUANTITY_2: "Cantidad 2",
  QUANTITY_3: "Cantidad 3",
  QUANTITY_4: "Cantidad 4",
  QUANTITY_5: "Cantidad 5",
  QUANTITY_6: "Cantidad 6",
  QUANTITY_7: "Cantidad 7",
  QUANTITY_8: "Cantidad 8",
  QUANTITY_9: "Cantidad 9",
  QUANTITY_10: "Cantidad 10",
  QUERY_MUST_CONTAIN_3_CHARACTERS: "La consulta debe contener al menos 3 caracteres",
  QUEST_DESC: "Descripci\xF3n Cuestionable",
  QUESTIONABLE_PART: "Pieza cuestionable",
  QUEUED: "En cola",
  REASON_FOR_CHANGE: "Raz\xF3n por cambio",
  REASON_FOR_DEBIT: "Raz\xF3n de d\xE9bito",
  REASON_FOR_MISSING_PLATE: "Raz\xF3n de la placa faltante",
  REASON_FOR_MISSING_PLATE_REQUIRED: "Raz\xF3n para la placa faltante requerida",
  REASON_FOR_OVERRIDE: "Raz\xF3n de anulaci\xF3n",
  REASON_FOR_REFUSAL: "Raz\xF3n de rechazo",
  REASON_FOR_RETURN: "Raz\xF3n de regreso",
  REASON_FOR_RETURN_IS_REQUIRED: "el raz\xF3n por el regreso es necesario.",
  REASON_FOR_TRANSFER: "Raz\xF3n de la transferencia",
  REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: "El razon por la transferencia debe incluir caracteres alfanum\xE9ricos",
  RECIPIENT_DEALER_OR_TCSM: "Destinatario(concesionario o TCSM)",
  RECIPIENT_MAILING: "Destinatario de correo",
  RECONCILE: "Conciliaci\xF3n",
  RECONCILE_CLAIM: "Conciliar reclamo",
  RECONCILED: "CONCILIADO",
  RECORD_AUDIT: "Registrar la auditor\xEDa",
  RECORD_AUDIT_FOR: "Registrar la auditor\xEDa para el distribuidor",
  RECORDS_FOUND: "{count, plural, one {Se encontr\xF3 {countToDisplay} registro} other {Se encontraron {countToDisplay} registros}}",
  RECOVERABLE_TAXES: "Impuestos recuperables",
  RECOVERED: "Recuperado",
  RECOVERED_WITH_MISSED_ADDITIVES: "Recuperado Con Aditivos Perdidos",
  RECOVERED_WITHOUT_ADDITIVES: "Recuperado Sin Aditivos",
  RECOVERY: "Recuperaci\xF3n",
  RED_MUST_BE_LESS_THAN_YELLOW: "El valor del indicador rojo debe ser menos que el valor del indicador amarillo",
  REFERENCE_1: "Referencia 1",
  REFERENCE_2: "Referencia 2",
  REFERENCE_INFORMATION: "Informaci\xF3n de Referencia",
  REFERENCE_NUMBER1: "N\xBA de Referencia1",
  REFERENCE_NUMBER2: "N\xBA de Referencia2",
  REGION: "Regi\xF3n",
  REGISTER: "Registrar",
  REGISTER_A_PRODUCT_BY_PIN: "Registrar un producto por PIN",
  REGISTER_A_PRODUCT_TO_ADD: "Registrar el producto para a\xF1adir al sistema de garant\xEDa",
  REGISTER_ANOTHER_PRODUCT: "Registrar Otro Producto",
  REGISTER_PRODUCT: "Registro de Producto",
  REGISTER_PRODUCT_AND_REGISTER_ANOTHER: "Registrar el producto y registrar otro",
  REGISTERED: "Registrado",
  REGISTRATION: "Registro",
  REGISTRATION_DATE: "Fecha de Registro",
  REGISTRATION_DATES: "Fechas de Registro",
  REGISTRATION_FORM: "Formulario de Registro",
  REGISTRATION_HISTORY: "Historial de Registro",
  REGISTRATION_NOT_ALLOWED: "No se permite registrar este producto",
  REGISTRATION_REVIEW: "Revisi\xF3n de Registro",
  REGISTRATION_REVIEW_TAB: "Revisi\xF3n de Registro ({count})",
  REGISTRATION_STATUS: "Estatus de Registro",
  REGISTRATION_STATUS_CANNOT_BE_NEW: "El Estado del Registro no puede ser Nuevo",
  REGISTRATION_STATUS_REQUIRED: "El estatus de registro es necesario",
  REGISTRATION_SUCCESS: "Registro exitoso",
  REGISTRATION_TYPE: "Tipo de Registro",
  REGISTRATION_TYPE_CANNOT_BE_NEW: "El Tipo de Registro no puede ser Nuevo",
  REGISTRATION_TYPE_REQUIRED: "El tipo de registro es necesario",
  REGISTRATION_UPDATED_SUCCESSFULLY: "Registro actualizado con \xE9xito",
  REGISTRATIONS_REVIEW: "Revisi\xF3n de Registros",
  REIMBURSED: "Reembolsado",
  REIMBURSED_AMOUNT: "Cantidad Reembolsada",
  REIMBURSED_PERCENTAGE: "Porcentaje Reembolsado",
  REIMBURSED_PERCENTAGE_INDICATOR: "Indicador de Porcentaje Reembolsado",
  REIMBURSEMENT_DETAILS: "Detalles del Reembolso",
  REIMBURSEMENT_PERCENTAGE: "Porcentaje de Reembolso",
  REIMBURSEMENT_SUMMARY: "Resumen de reembolsos",
  REJECT: "Rechazar",
  REJECT_LABOR_RATE: "Rechazar la tasa de trabajo",
  REJECT_SPECIAL_ALLOWANCE_CLAIM: "Rechazar el reclamo de la prestaci\xF3n especial",
  REJECTED: "Rechazado",
  REJECTED_APPEAL: "Solicitud Rechazada",
  RELATIONSHIP: "Relaci\xF3n",
  RELATIONSHIP_IS_REQUIRED: "La relaci\xF3n es necesaria.",
  REMOVE_FILTER: "Eliminar Filtro",
  REMOVE_FROM_AUDIT: "Quitar de Auditor\xEDa",
  REMOVE_LAYOUT: "Eliminar dise\xF1o de p\xE1gina",
  RENTAL_PINS: "PIN de alquiler",
  REPAIR_DATE: "Fecha de Reparo",
  REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: "La fecha de reparaci\xF3n no puede ser anterior a la fecha de falla",
  REPAIR_NUMBER: "N\xFAmero de reparaci\xF3n",
  REPAIR_NUMBER_IS_REQUIRED: "El n\xFAmero de reparaci\xF3n es necesario.",
  REPAIR_REPLACE_INDICATOR: "Indicador de Reparaci\xF3n/Reemplazo",
  REPAIRED: "Reparaci\xF3n",
  REPAIRED_DATE: "Fecha de Reparaci\xF3n",
  REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: "La fecha de reparaci\xF3n no puede ser anterior a la fecha de la falla.",
  REPAIRED_DATE_IS_REQUIRED: "La fecha de la reparaci\xF3n es necesaria.",
  REPORT_DATE: "Fecha del Informe",
  REPORT_NUMBER: "N\xFAmero de Informe",
  REPORTS: "Reportes",
  REQ_ADDL: "Ajuste Nota de Cr\xE9dito",
  REQUEST_DATE: "Fecha de Solicitud",
  REQUEST_DETAILS: "Detalles de la solicitud",
  REQUEST_DUPLICATE_PIN_PLATE: "Solicitud de placa de PIN duplicada",
  REQUEST_FORM: "Formularios de Solicitud",
  REQUEST_PIP_CODE: "Solicitar C\xF3digo de PIP",
  REQUEST_STATUS: "Solicitude estado",
  REQUEST_SUBMITTED: "Solicitud Enviada",
  REQUEST_TYPE: "Typo de solicitud",
  REQUEST_UPDATED_SUCCESSFULLY: "Solicitud actualizada exitosa",
  REQUEST_WARRANTY_CLAIM_DEBIT: "Solicitar debito del reclamo de garant\xEDa",
  REQUESTED: "Solicitado",
  REQUESTED_BY: "Solicitado Por",
  REQUESTED_DATE: "Fecha de Solicitud",
  REQUESTED_DATES: "Fechas Solicitadas",
  REQUESTED_DIAGNOSTIC_AMOUNT: "Monto de diagn\xF3stico solicitado",
  REQUESTED_DIAGNOSTIC_HOURS: "Horas de diagn\xF3stico solicitado",
  REQUESTED_LABOR_AMOUNT: "Cantidad de Mano de Obra Solicitada",
  REQUESTED_LABOR_HOURS: "Horas de Mano de Obra Solicitadas",
  REQUESTED_OTHER_CREDITS: "Otros Cr\xE9ditos Solicitados",
  REQUESTED_PARTS: "Piezas Solicitadas",
  REQUESTED_REPAIR_AMOUNT: "Monto de reparaci\xF3n solicitado",
  REQUESTED_REPAIR_HOURS: "Horas de reparaci\xF3n solicitado",
  REQUESTED_TRAVEL_TOTAL: "Total de Desplazamiento Solicitado",
  REQUESTER_TCSM: "Solicitante (TCSM)",
  REQUESTER_TCSM_REQUIRED: "Solicitante (TCSM) requerido",
  REQUIRED: "*Necesario/a",
  REQUIRED_CRITERIA: "Criterios Requeridos",
  REQUIRED_ITEMS: "Art\xEDculos requeridos",
  RESEND_XML: "Volver a enviar XML",
  RESET: "Reajustar",
  RESPONDENT_INFORMATION: "Informaci\xF3n del Encuestado",
  RESPONSIBILITY_OF: "Responsabilidad de",
  RESPONSIBLE_ACCOUNT: "Cuenta Responsable",
  RESPONSIBLE_ACCOUNT_IS_REQUIRED: "La cuenta responsible es necesaria",
  RESPONSIBLE_DEALER: "Distribuidor/Concesi\xF3n Responsable",
  RET: "Devoluci\xF3n",
  RETAIL_INSTALL: "Venta/Instalaci\xF3n",
  RETAIL_INSTALL_DATE: "Fecha de Instalaci\xF3n",
  RETAIL_INSTALL_IS_REQUIRED: "El campo Venta/Instalaci\xF3n es obligatorio.",
  RETAILER_NAME: "Nombre del comercio de auto servicio",
  RETAILER_NAME_IS_REQUIRED: "El nombre del minorista es necesario.",
  RETRY: "volver a intentar",
  RETURN: "Devoluci\xF3n",
  RETURN_LABOR_RATE: "Tarifa de Mano de Obra de Retorno",
  RETURN_REQUESTS: "Solicitud de devoluci\xF3n",
  RETURN_SPECIAL_ALLOWANCE_CLAIM: "Devolver el reclamo de la prestaci\xF3n especial",
  RETURN_STATUS: "Estatus de devoluci\xF3n",
  RETURNED: "Devuelta",
  RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: "La fecha de devoluci\xF3n no puede ser anterior a la fecha de entrega.",
  RETURNED_DATE_IS_REQUIRED: "La fecha de devoluci\xF3n es necesaria.",
  REVIEW_DEALER_RECOMMENDATIONS: "\xBFEst\xE1 seguro de que desea marcar la clavija para Revisi\xF3n?",
  REVISE: "Revisar",
  REVISED: "Revisada",
  ROLLING_12_CREDIT_AMOUNT: "12 meses de monto de credito",
  ROLLING_12_MONTHS: "12 Meses Continuos",
  RUN_REPORT: "Ejecutar Informe",
  RUSSIAN: "Ruso",
  SAP_DOWN_WARNING: "La funcionalidad del sistema de garant\xEDa est\xE1 menoscabada. Estamos trabajando para corregir esto lo antes posible. Actualizar el navegador para comprobar la disponibilidad del sistema.",
  SAVE: "Guardar",
  SAVE_AS_DRAFT: "Guardar como Borrador",
  SAVE_AS_NEW_LAYOUT: "Guardar como nuevo dise\xF1o",
  SAVE_AUDIT: "Guardar Auditor\xEDa",
  SAVE_CHANGES: "Guardar Cambios",
  SAVE_TO_VALIDATE: "Guardar para validar",
  SAVE_VALD: "Guardar y Validar",
  SAVE_VALIDATE: "Guardar y Validar",
  SEARCH: "Buscar",
  SEARCH_BOX_PLACEHOLDER: "Rellenar PIN, N.\xBA de Serie, N.\xBA de Reclamo, Caso de DTAC o Nombre del Cliente",
  SEARCH_BY_CLAIM_TYPE: "Rellenar tipo de reclamo completo.",
  SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: "La b\xFAsqueda de reclamo debe ser por el tipo de reclamo completo, de 4 a 9 caracteres.",
  SEARCH_BY_FAILURE_PART_NUMBER: "rellenar n\xFAmero completo de la parte de fallo.",
  SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: "La b\xFAsqueda de reclamo debe ser por el n\xFAmero completo de la parte de fallo,m\xEDnimo de 4 caracteres.",
  SEARCH_BY_WORK_ORDER: "Rellenar orden de trabajo, m\xEDnimo de 2 caracteres.",
  SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: "La b\xFAsqueda de orden de trabajo debe ser de m\xEDnimo de 2 caracteres.",
  SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: "Rellenar n\xFAmero de reclamo completo",
  SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: "La b\xFAsqueda de reclamo debe ser por el n\xFAmero de reclamo, de 4 a 9 caracteres.",
  SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: "Rellenar n\xFAmero de serie completo del componente",
  SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: "La b\xFAsqueda de componentes debe ser por el n\xFAmero de serie completo, al menos 1 car\xE1cter",
  SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: "Introducir PIN",
  SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: "Rellenar n\xFAmero de modelo completo",
  SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: "La b\xFAsqueda de modelo debe ser por el n\xFAmero de modelo completo, de 3 a 12 caracteres",
  SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: "Rellenar PIN, m\xEDnimo de 6 caracteres",
  SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: "La b\xFAsqueda de PIN debe ser de 6 a 17 caracteres.",
  SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: "Rellenar el numero de PIP, m\xEDnimo de 4 caracteres",
  SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: "La b\xFAsqueda de PIP debe ser de 4 a 12 caracteres",
  SEARCH_RESULTS_TAB: "Resultados de la B\xFAsqueda ({count})",
  SECOND_SHIP_TO_LOCATION: "Segundo Env\xEDo a Ubicaci\xF3n",
  SELECT: "Seleccionar",
  SELECT_A_RANGE: "Seleccionar un gama",
  SELECT_ALL: "Seleccionar Todo",
  SELECT_AUTO_SUBMIT: "Seleccionar Enviar Autom\xE1ticamente",
  SELECT_BRANCH: "Seleccionar un sucursal",
  SELECT_CLAIM_TYPE: "Seleccionar tipo de reclamo",
  SELECT_CLAIMS: "Seleccionar Reclamos",
  SELECT_CLAIMS_WITHIN_DATE_RANGE: "Seleccionar Reclamos Dentro de Rango de Fechas",
  SELECT_COLUMNS: "Seleccionar columnas",
  SELECT_COUNTRY: "Seleccionar pa\xEDs",
  SELECT_CSV_SEPARATOR: "Seleccionar separador CSV",
  SELECT_DATE_FORMAT: "Seleccionar Formato de Fecha",
  SELECT_DEALERS_AND_STATUS: "Seleccionar distribuidores y estado",
  SELECT_DECIMAL_FORMAT: "Seleccionar Formato Decimal",
  SELECT_DISPLAY_FORMAT: "Seleccionar formato de visualizaci\xF3n",
  SELECT_FACTORY: "Seleccionar F\xE1brica",
  SELECT_LANGUAGE: "Seleccionar Idioma",
  SELECT_LAYOUT: "Seleccionar Dise\xF1o de p\xE1gina",
  SELECT_NEW_CLAIMS: "Seleccionar Nuevos Reclamos",
  SELECT_PIP_CODE: "Seleccionar c\xF3digo PIP",
  SELECT_PLAN_NAMES: "Seleccionar Nombres del Plan",
  SELECT_SERVICE_INTERVAL_TYPES: "Seleccionar tipos de intervalo de servicio",
  SELECT_SORT_BY: "Seleccionar Ordenar Por",
  SELECT_SORT_DIRECTION: "Seleccionar Direcci\xF3n de Orden",
  SELECT_STATE: "Seleccionar Estado",
  SELECT_STATUS: "Seleccionar estatus",
  SELECT_TERRITORY: "Seleccionar territorio",
  SELECT_THEME: "Seleccionar Tema",
  SELECT_TIME_ZONE: "Seleccionar Zona Horaria",
  SELECT_VALUES_TO_APPROVE: "Seleccionar Valores para Aprobar",
  SELECTED_COLUMNS: "Columnas Seleccionadas",
  SELECTED_FOR_AUDIT: "Seleccionado para Auditor\xEDa",
  SELECTED_FOR_AUDIT_VSR: "Consultar la soluci\xF3n DTAC 221475 para la documentaci\xF3n de auditor\xEDa requerida y los accesorios necesarios para esta reclamaci\xF3n",
  SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: "Selecci\xF3n de varios tipos de cuentas y tipos de garant\xEDa afecta el rendimiento",
  SEND: "Enviar",
  SERIAL_NUMBER: "N\xFAmero de Serie",
  SERIAL_NUMBER_INVOICE_NUMBER: "N\xFAmero de Serie / N\xFAmero de Factura",
  SERVER_TOOK_TOO_LONG_TO_REPLY: "El servidor tard\xF3 demasiado en responder y la solicitud se cancel\xF3. Intente una solicitud m\xE1s espec\xEDfica o vuelva a intentarlo m\xE1s tarde.",
  SERVICE_DATE_IS_REQUIRED: "La fecha de servicio es necesaria.",
  SERVICE_INTERVAL: "El intervalo de servicio es necesario",
  SERVICE_INTERVAL_BEGIN_DATE: "Fecha de Inicio del Intervalo de Servicio",
  SERVICE_INTERVAL_END_DATE: "Fecha de Finalizaci\xF3n del Intervalo de Servicio",
  SERVICE_INTERVAL_IS_REQUIRED: "El campo Intervalo de Mantenimiento es obligatorio.",
  SERVICE_INTERVAL_NUMBER: "N\xFAmero de Intervalo de Servicio",
  SERVICE_INTERVAL_STATUS: "Estatus de Intervalo de Servicio",
  SERVICE_INTERVAL_TYPE: "Tipo de Intervalo de Servicio",
  SERVICE_INTERVAL_TYPES: "Tipos de Intervalos de Servicio",
  SERVICE_PART: "Parte de servicio",
  SERVICE_UNAVAILABLE: "Servicio No Disponible",
  SERVICED: "Mantenimiento",
  SERVICED_DATE_IS_REQUIRED: "Se requiere fecha de servicio.",
  SERVICED_IS_REQUIRED: "Se requiere fecha de servicio.",
  SET_AS_DEFAULT: "Establecer por defecto",
  SETTINGS: "Mi Configuraci\xF3n",
  SETTLED: "Liquidado",
  SETTLEMENT_NO_REGISTRATION: "Liquidaci\xF3n Sin Registro",
  SETUP: "Configuraci\xF3n",
  SETUP_DATE_IS_REQUIRED: "La fecha de configuraci\xF3n es necesaria.",
  SETUP_IS_REQUIRED: "La configuraci\xF3n es necesaria.",
  SGST_UTGST: "SGST/UTGST",
  SHIP_TO: "Enviar a",
  SHIPPED: "Enviado",
  SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: "Informaci\xF3n de env\xEDo/instrucciones especiales",
  SHIPPING_INSTRUCTIONS: "Instrucciones de Env\xEDo",
  SHORT_TEXT: "Texto corto",
  SHORT_TEXT_IS_REQUIRED: "Se requiere texto corto",
  SHOW_ALL: "Mostrar todo ({count})",
  SHOW_EXCLUDED: "Mostrar Excluidos",
  SHOW_MORE: "Mostrar m\xE1s",
  SHOW_MORE_GROUPS: "Mostrar {countToDisplay} {count, plural, one {grupo m\xE1s} other {grupos m\xE1s}}",
  SHOW_RED_IF_LESS_THAN: "Mostrar en Rojo si es Menor que",
  SHOW_REIMBURSED_AMOUNT: "Mostrar Cantidad Reembolsada",
  SHOW_REIMBURSED_PERCENTAGE: "Mostrar Porcentaje Reembolsado",
  SHOW_YELLOW_IF_LESS_THAN: "Mostrar en Amarillo si es Menor que",
  SIGN_IN_REQUIRED: "Inicio de sesi\xF3n requerido",
  SIGN_OUT: "Desloguearse",
  SKIP_AUDIT: "Saltar auditor\xEDa",
  SKIP_AUDIT_SUCCESS: "Se ha omitido la auditor\xEDa y la fecha de vencimiento est\xE1 en el futuro.",
  SOME_PARTS_RETURNED: "Algunas Piezas Devueltas",
  SORT_BY: "Ordenar Por",
  SPANISH: "Espa\xF1ol",
  SPECIAL_ALLOWANCE: "Prestaci\xF3n especial",
  SPECIAL_ALLOWANCE_CALCULATION: "C\xE1lculo de prestaci\xF3n especial",
  SPECIAL_ALLOWANCE_CLAIM: "Reclamaci\xF3n de prestaci\xF3n especial",
  SPECIAL_ALLOWANCE_CLAIM_STATUS: "Estado de la reclamaci\xF3n de beneficios especiales",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: "Estado de la reclamaci\xF3n de beneficios especiales",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: "Estado de la reclamaci\xF3n de beneficios especiales actualizado",
  SPECIAL_ALLOWANCE_CLAIM_WITH_ID: "Reclamaci\xF3n de prestaci\xF3n especial {claimNumber}",
  SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: "Reclamaciones de de prestaciones especiales ({count})",
  SPECIAL_ALLOWANCE_CONTRIBUTIONS: "Contribuciones de prestaci\xF3n especial",
  SPECIAL_ALLOWANCE_DESCRIPTION: "Descripci\xF3n de prestaci\xF3n especial",
  SPECIAL_ALLOWANCE_TYPE: "Tipo de prestaci\xF3n especial",
  SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: "Tipo de prestaci\xF3n especial es necesario.",
  SPECIAL_INSTRUCTIONS: "Instr. Especiales",
  SPG: "SPG",
  SPGS: "SPG",
  STANDARD_VIEW: "Vista est\xE1ndar",
  START_AMOUNT_OF_USE: "Inicio cantidad de uso ",
  STARTS: "Comienza",
  STARTS_WITH: "Comienza con",
  STATE: "Estado",
  STATE_PROVINCE: "Estado/Provincia",
  STATE_PROVINCE_REQUIRED: "Estado/provincia requeridos",
  STATUS: "Estatus",
  STATUS_CHANGE_REQUEST: "Cambio de estatus solicitud",
  STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: "Cambio de estatus solicitud creado correctamente ",
  STATUS_FOR: "Estatus para PIN",
  STATUS_INDICATOR: "Indicador de Estatus",
  STATUS_REASON: "Raz\xF3n de Estatus",
  STOLEN_DATE: "Fecha robada",
  STORE: "Tienda",
  STORE_IS_REQUIRED: "La tiendo es necesaria.",
  STORE_NUMBER_IS_REQUIRED: "El n\xFAmero de tienda es necesario.",
  STREET_1: "Calle 1",
  STREET_2: "Calle 2",
  SUB: "Entregar",
  SUB_CLAIM_TYPE: "Tipo de Garant\xEDa Sustituida",
  SUB_TYPE: "Subtipo",
  SUBMISSION_DATE: "Fecha de entrega",
  SUBMIT: "Enviar/Entregar",
  SUBMIT_AUDIT: "Enviar Auditor\xEDa",
  SUBMIT_AUDIT_FOR: "Enviar Auditor\xEDa Para {dealer}",
  SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Enviar Reclamaci\xF3n de D\xE9bito Total para {claimNumber}",
  SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Enviar Reclamaci\xF3n de D\xE9bito Parcial para {claimNumber}",
  SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Enviar Reclamaci\xF3n de d\xE9bito porcentual para {claimNumber}",
  SUBMIT_REQUEST: "Enviar Solicitud",
  SUBMITTED: "Enviada",
  SUBMITTED_AVAILABLE_TO_EDIT: "Enviada (Editable)",
  SUCCESS: "\xC9xito",
  SUCCESS_MESSAGE_TITLE: "La operaci\xF3n se realiz\xF3 correctamente:",
  SUCCESS_MESSAGES_TITLE: "Varias operaciones se realizaron correctamente:",
  SUPPLIER_WARRANTY: "Garant\xEDa del Proveedor",
  SURVEY_QUESTIONS: "Preguntas de la Encuesta",
  SUSPENDED: "Suspendido",
  SWEDISH: "Sueco",
  SYSTEM_SELECTED_CLAIMS: "Reclamaciones Seleccionadas por el Sistema",
  SYSTEM_SELECTED_CLAIMS_WITH_COUNT: "Reclamaciones Seleccionadas por el Sistema ({count})",
  TABM: "TABM",
  TAX: "Impuestos",
  TCSM: "TCSM",
  TECH_ID: "C\xF3digo T\xE9cnico",
  TERMINATED: "Terminado",
  TERMINATES: "Termina",
  TERRITORY: "Territorio",
  TEST: "Prueba",
  TEST_RESULTS_CODE: "C\xF3digo",
  THEME: "Tema",
  TIME_LIMIT: "L\xEDmite de Tiempo",
  TIME_ZONE: "Zona Horaria",
  TITLE: "T\xEDtulo",
  TITLE_IS_REQUIRED: "Se requiere tT\xEDtulo",
  TO: "a",
  TODAY: "Hoy",
  TOO_MANY_RESULTS: "Su solicitud arroj\xF3 demasiados resultados. Por favor, reduzca sus t\xE9rminos de b\xFAsqueda e int\xE9ntelo de nuevo.",
  TOTAL: "Total",
  TOTAL_AMOUNT: "Monto Total",
  TOTAL_APPROVED: "Total Aprobado",
  TOTAL_APPROVED_CLAIM_VALUE: "Importe Total Aprobado",
  TOTAL_APPROVED_INCLUDING_TAXES: "Importe total aprobado incluyendo impuestos",
  TOTAL_APPROVED_WITHOUT_ADDITIVES: "Importe total aprobado sin aditivos",
  TOTAL_CONTRIBUTION: "Contribuci\xF3n Total",
  TOTAL_REIMBURSED: "Total Reembolsado",
  TOTAL_REIMBURSED_WITH_CURRENCY: "Total Reembolsado ({currency})",
  TOTAL_REQUESTED: "Total solicitado",
  TOTAL_REQUESTED_CLAIM_VALUE: "Importe Total Solicitado",
  TOTAL_UNPAID: "Total Sin Pagar",
  TRACKING_NUMBER: "N\xFAmero de rastreo",
  TRANSFER: "Transferir",
  TRANSFER_APPROVALS: "Aprobaciones de Transferencia",
  TRANSFER_APPROVALS_TAB: "Aprobaciones de Transferencia ({count})",
  TRANSFER_CREATED: "Transferencia Creada",
  TRANSFER_DEALER_RECOMMENDATIONS: "\xBFEst\xE1 seguro de que desea transferir el pasador a otro concesionario?",
  TRANSFER_UPDATED_SUCCESSFULLY: "Transferencia actualizada correctamente",
  TRANSFERS: "Transferencias",
  TRAVEL: "Desplazamiento",
  TURKISH: "Turco",
  TWO_PERCENT_WITHHOLD_VALUE: "2% retienen valor",
  TYPE: "Tipo",
  TYPES: "Tipos",
  UNABLE_TO_CONTACT_THE_SERVER: "No se puede comunicar con servidor",
  UNABLE_TO_LOAD_CUSTOMER_DETAILS: "No se puede descargar los detalles del cliente",
  UNDO: "Deshacer",
  UNDO_REGISTRATION: "Deshacer registro",
  UNDO_REGISTRATION_SUCCESSFULL: "El registro de Deshacer es exitoso",
  UNIT: "Unidad",
  UNIT_1: "Unidad 1",
  UNIT_2: "Unidad 2",
  UNIT_3: "Unidad 3",
  UNIT_OF_MEASURE: "Unidad de Medida",
  UNPAID_LABOR: "Trabajo Sin Pagar",
  UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: "Aditivos por Mano de Obra Sin Pagar - excluyendo PIPs",
  UNPAID_LABOR_ADDITIVES_PIPS: "Aditivos por Mano de Obra Sin Pagar - PIP",
  UNPAID_OTHER_CREDITS: "Otros cr\xE9ditos sin pagar",
  UNPAID_PARTS: "Piezas Sin Pagar",
  UNPAID_PARTS_ADDITIVE: "Aditivos por piezas sin pagar",
  UNPAID_TRAVEL: "Viajes sin pagar",
  UNSUB: "Editar",
  UNSUBMIT_CLAIM: "Editar Reclamaci\xF3n",
  UPDATE_CUSTOMER_INFORMATION: "Actualice informaci\xF3n del cliente",
  UPDATE_LABOR_RATES: "Actualizar costos laborales",
  UPDATE_LAYOUT: "Dise\xF1o de p\xE1gina de actualizaci\xF3n",
  UPDATE_MACHINE_STATUS: "Actualizar estatus de maquina",
  UPDATE_MACHINE_STATUS_HISTORY: "Actualizar el Historial del Estado de la M\xE1quina",
  UPDATE_REGISTRATION: "Actualizar registro",
  UPDATE_SELECTED: "Actualizar selecci\xF3n",
  UPDATED: "Actualizado",
  UPDATED_BY: "Actualizado por",
  UPLOAD_DOCUMENT: "Subir documento",
  UPTIME_ASSURANCE: "Seguro de tiempo operativo",
  USEFUL_LINKS: "Enlaces \xDAtiles",
  USER: "usuario",
  USER_PREFERENCES_UPDATED: "Preferencias del usuario actualizadas",
  USER_SELECTED: "Usuario Seleccionado",
  USER_SELECTED_CLAIMS_WITH_COUNT: "Reclamaciones Seleccionadas por el Usuario ({count})",
  USERS_INFORMATION: "Informaci\xF3n de usuarios",
  VALIDATE: "Validar",
  VALIDATE_CLAIM: "Validar Reclamaci\xF3n",
  VALUE: "Valor",
  VALUE_OF_REPAIR: "Valor de Reparaci\xF3n",
  VIEW_CLAIM: "Ver Reclamaci\xF3n",
  VIEW_DETAILS: "Ver Detalles",
  VIEW_OPEN_PIPS: "Ver PIP Abiertos",
  VIEW_PIP: "Ver PIP",
  VIEW_PRODUCTS: "Ver productos",
  VIEW_PRODUCTS_AND_UPDATE_INFO: "Ver productos y Actualizar Informaci\xF3n",
  VIEW_UPDATE: "Ver/Actualizar",
  VSR_MESSAGES: "Mensajes VSR",
  WAITING_FOR_DLR_INV: "Esperando factura de distribuidor",
  WAITING_FOR_INVOICE: "Esperando factura ({count})",
  WAITING_SINCE: "Esperando desde",
  WARNING_MESSAGE_TITLE: "Se envi\xF3 una advertencia:",
  WARNING_MESSAGES: "Mensajes de Advertencia",
  WARNING_MESSAGES_TITLE: "Se enviaron varias advertencias:",
  WARRANTY: "Garant\xEDa",
  WARRANTY_ADMIN: "Garant\xEDa Administrador",
  WARRANTY_CLAIM_TYPE: "Tipo de reclamaci\xF3n de garant\xEDa",
  WARRANTY_COVERAGE: "Cobertura de Garant\xEDa",
  WARRANTY_EXPIRATION: "Vencimiento de la Garant\xEDa",
  WARRANTY_TYPE: "Tipo de Garant\xEDa",
  WARRANTY_TYPES: "Tipos de Garant\xEDa",
  WEAR_PARTS: "Piezas de desgaste",
  WEAR_PARTS_COVERAGE: "Cobertura de piezas de desgaste",
  WELCOME: "Bienvenido",
  WIP: "Trabajo en Progreso",
  WITH_ADDITIVES: "Con Aditivos",
  WITNESS_FIRST_NAME: "Nombre del Testigo",
  WITNESS_LAST_NAME: "Apellido del Testigo",
  WORK_ORDER: "Orden de trabajo",
  WORK_ORDER_NUMBER: "N\xFAmero de orden de trabajo",
  WORK_ORDER_ONE: "Orden de trabajo 1",
  WORK_ORDER_ONE_IS_REQUIRED: "El orden de trabajo es necesario.",
  WORK_ORDER_THREE: "Orden de trabajo 3",
  WORK_ORDER_THREE_IS_REQUIRED: "El orden de trabajo 3 es necesario.",
  WORK_ORDER_TWO: "Orden de trabajo 2",
  WORK_REPAIR_ORDER: "Orden de reparaci\xF3n de trabajo",
  YES: "S\xED",
  YES_LOWERCASE: "S\xED"
});